/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable sort-keys */
/* eslint-disable camelcase */
/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Tadaah API
 * Documentation for API's to be used for Tadaah.
 * OpenAPI spec version: v1
 */
import { useQuery, useMutation } from 'react-query';
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from 'react-query';

import { customInstance } from '../custom-instance';
import type { ErrorType } from '../custom-instance';

export type ApiPeriodJobsListParams = {
  travel_distance?: number;
  min_rate?: number;
};

export type ApiOrganisationSdbListParams = {
  start_date: string;
  end_date: string;
};

export type ApiOrganisationUsersDetailsListJobType =
  typeof ApiOrganisationUsersDetailsListJobType[keyof typeof ApiOrganisationUsersDetailsListJobType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiOrganisationUsersDetailsListJobType = {
  job_ad: 'job_ad',
  period_job: 'period_job',
} as const;

export type ApiOrganisationUsersDetailsListParams = {
  job_type?: ApiOrganisationUsersDetailsListJobType;
};

export type ApiOrganisationJobsExportListFileType =
  typeof ApiOrganisationJobsExportListFileType[keyof typeof ApiOrganisationJobsExportListFileType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiOrganisationJobsExportListFileType = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ApiOrganisationJobsExportListParams = {
  from_date: string;
  to_date: string;
  organisation?: string;
  location?: string;
  job_type?: string;
  assigned_status?: string;
  assigned_to?: string;
  file_type: ApiOrganisationJobsExportListFileType;
};

export type ApiOrganisationJobsList200 = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: OrganisationJobs[];
};

export type ApiOrganisationJobsListParams = {
  from_date: string;
  to_date: string;
  organisation?: string;
  location?: string;
  job_type?: string;
  assigned_status?: string;
  assigned_to?: string;
  page?: number;
  page_size?: number;
};

export type ApiOrganisationFreelancersDetailsListJobType =
  typeof ApiOrganisationFreelancersDetailsListJobType[keyof typeof ApiOrganisationFreelancersDetailsListJobType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiOrganisationFreelancersDetailsListJobType = {
  job_ad: 'job_ad',
  period_job: 'period_job',
} as const;

export type ApiOrganisationFreelancersDetailsListParams = {
  job_type?: ApiOrganisationFreelancersDetailsListJobType;
};

export type ApiOrganisationFreelancerAvailabilityReadParams = {
  from_date?: string;
  to_date?: string;
  from_time?: string;
  to_time?: string;
};

export type OrganisationListFavoriteFreelancersUser200 = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: UserList[];
};

export type OrganisationListFavoriteFreelancersUserParams = {
  page?: number;
  page_size?: number;
};

export type OrganisationListBlockedFreelancersUser200 = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: UserList[];
};

export type OrganisationListBlockedFreelancersUserParams = {
  page?: number;
  page_size?: number;
};

export type ApiJobsAvailableListType =
  typeof ApiJobsAvailableListType[keyof typeof ApiJobsAvailableListType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiJobsAvailableListType = {
  any: 'any',
  personal: 'personal',
  urgent: 'urgent',
  choice: 'choice',
} as const;

export type ApiJobsAvailableListParams = {
  travel_distance?: number;
  min_rate?: number;
  whole_days?: boolean;
  new?: boolean;
  type?: ApiJobsAvailableListType;
  post_code?: string;
  organisation?: number;
  competences?: string;
  if_available?: boolean;
  limit?: number;
  offset?: number;
};

export type ApiFreelancersKvkListParams = { kvk_number: string };

export type ApiFreelancersListRepeatDaysItem =
  typeof ApiFreelancersListRepeatDaysItem[keyof typeof ApiFreelancersListRepeatDaysItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiFreelancersListRepeatDaysItem = {
  '0': 0,
  '1': 1,
  '2': 2,
  '3': 3,
  '4': 4,
} as const;

export type ApiFreelancersListCertificatesItem =
  typeof ApiFreelancersListCertificatesItem[keyof typeof ApiFreelancersListCertificatesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiFreelancersListCertificatesItem = {
  bhv: 'bhv',
  ehbo: 'ehbo',
  vve: 'vve',
  taaleis: 'taaleis',
  baby: 'baby',
} as const;

export type ApiFreelancersListParams = {
  date: string;
  start: string;
  end: string;
  pause: number;
  location_id?: string;
  location_lat_lon?: string;
  location_full_address?: string;
  competence?: string;
  certificates?: ApiFreelancersListCertificatesItem[];
  is_repeat?: boolean;
  repeat_days?: ApiFreelancersListRepeatDaysItem[];
  repeat_end?: string;
  max_rate?: number;
};

export type ApiAutocompleteUserOrganisationsListParams = { q?: string };

export type ApiAutocompleteUserLocationsListParams = { q?: string };

export type ApiAutocompleteOrganisationsListParams = { q?: string };

export type ApiAutocompleteLocationsListParams = { q?: string };

export type ApiAutocompleteFreelancersListParams = { q?: string };

export type ApiAutocompleteFreelancersUsersListParams = { q?: string };

export type ApiAutocompleteDocumentTypeListParams = { q?: string };

export type ApiAutocompleteAssigneesListParams = { q?: string };

export type FavoritesAndBlockedActionBody = FavoritesAndBlockedAction;

export type ChangePasswordBody = ChangePassword;

export type UserBody = User;

export type AvailableDaysBody = AvailableDays;

export type FreelancerBody = Freelancer;

export type OutstandingInvoiceCreateParamsBody = OutstandingInvoiceCreateParams;

export type NotificationPreferencesBody = NotificationPreferences;

/**
 * This is the response when freelancer is **unverified**.
 */
export interface WelcomeUnverifiedResponse {
  full_name: string;
  verified: boolean;
  personal_data_percent: number;
  company_data_percent: number;
  documents_percent: number;
  diplomas_percent: number;
}

export type MessageType = typeof MessageType[keyof typeof MessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageType = {
  warning: 'warning',
  info: 'info',
} as const;

export interface Message {
  type: MessageType;
  message: string;
}

/**
 * This is the response when freelancer is **verified**.
 */
export interface WelcomeVerifiedResponse {
  full_name: string;
  vat_exempt: boolean;
  verified: boolean;
  messages: Message[];
  notifications: string;
}

export interface WelcomeAPIResponse {
  if_user_verified: WelcomeVerifiedResponse;
  if_user_unverified: WelcomeUnverifiedResponse;
}

export interface GeneralStats {
  freelancers: number;
  organisations: number;
  jobs: number;
}

export interface SignUpStatus {
  full_name: string;
  verified: boolean;
  personal_info_percent: number;
  kvk_registration_percent: number;
  documents_percent: number;
  diplomas_certificates_percent: number;
}

export type SignupAcquainted =
  typeof SignupAcquainted[keyof typeof SignupAcquainted];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignupAcquainted = {
  viavia: 'viavia',
  facebook: 'facebook',
  instagram: 'instagram',
  linkedin: 'linkedin',
  indeed: 'indeed',
  jobbird: 'jobbird',
  kinderopvangtotaal: 'kinderopvangtotaal',
  google_search: 'google_search',
  google_ad: 'google_ad',
} as const;

export interface Signup {
  username: string;
  first_name: string;
  last_name: string;
  password1: string;
  password2: string;
  email: string;
  acquainted: SignupAcquainted;
}

export interface PasswordResetConfirm {
  new_password1: string;
  new_password2: string;
  uid: string;
  token: string;
}

export interface PasswordReset {
  email: string;
}

/**
 * Beoordeling van de werkzaamheden.
 */
export type RatingDetailsRating =
  typeof RatingDetailsRating[keyof typeof RatingDetailsRating];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RatingDetailsRating = {
  '1': 1,
  '2': 2,
  '3': 3,
  '4': 4,
  '5': 5,
} as const;

export interface RatingDetails {
  /** Beoordeling van de werkzaamheden. */
  rating?: RatingDetailsRating;
  /** Toelichting op de beoordeling */
  feedback?: string | null;
}

export interface Rating {
  /** Id of the job */
  job: number;
  rating: number;
  feedback: string;
  manager_name?: string;
  manager_email?: string;
}

export interface PeriodJob {
  readonly id?: number;
  readonly organisation?: string;
  readonly location?: string;
  readonly parking_free?: string;
  readonly full_address?: string;
  readonly lat_lon?: string;
  from_date: string;
  to_date: string;
  start_time: string;
  end_time: string;
  /** Vul het aantal minuten pauze in */
  pause: number;
  readonly weekdays?: string[];
  readonly competence?: string;
  readonly certificates?: string[];
  /** Maximaal uurtarief wat jullie willen betalen (Excl BTW) */
  max_rate?: number | null;
  readonly max_rate_incl?: number;
  readonly max_rate_exempt?: number;
  remarks?: string | null;
  readonly travel_distance?: number;
  readonly is_interested?: boolean;
  readonly actual_rate?: number;
  readonly actual_rate_incl?: number;
  readonly actual_rate_exempt?: number;
}

/**
 * Benodigde competentie
 */
export type SDBJobsCreateCompetence =
  typeof SDBJobsCreateCompetence[keyof typeof SDBJobsCreateCompetence];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SDBJobsCreateCompetence = {
  baby: 'baby',
  dreumes: 'dreumes',
  peuter: 'peuter',
  verticaal: 'verticaal',
  speelzaal: 'speelzaal',
  bso: 'bso',
  vve: 'vve',
  pedagoog: 'pedagoog',
  pbgl: 'pbgl',
  wbgl: 'wbgl',
  abgl: 'abgl',
  kantoor: 'kantoor',
  lvd: 'lvd',
} as const;

export interface SDBJobsCreate {
  readonly id?: number;
  sdb_job_id: string;
  /** Benodigde competentie */
  competence: SDBJobsCreateCompetence;
  certificates?: string | null;
  /** Vul de datum in (bijv. 2017-10-21) */
  date: string;
  /** Vul de starttijd in (bijv. 10:00) */
  start: string;
  /** Vul de eindtijd in (bijv. 18:30) */
  end: string;
  /** Vul het aantal minuten pauze in */
  pause: number;
  /** Opmerkingen over de opdracht (optioneel) */
  remarks?: string | null;
  invite_only?: boolean;
  accept_now?: boolean;
  last_accepted?: string | null;
  /** Uurtarief (Excl BTW) */
  rate?: number | null;
  /** Uurtarief (Vrijgesteld) */
  rate_exempt?: number | null;
  /** Maximaal uurtarief wat jullie willen betalen (Excl BTW) */
  max_rate?: number | null;
  /** Maximaal uurtarief wat jullie willen betalen (Vrijgesteld) */
  max_rate_exempt?: number | null;
  cancelled?: boolean;
  late_cancellation?: boolean;
  worked_start?: string | null;
  worked_end?: string | null;
  worked_pause?: number | null;
  readonly created_at?: string;
  callback?: string | null;
  /** Kies de organisatie */
  organisation: number;
  /** Kies de vestiging waar u een invaller nodig heeft. Is de lijst leeg,<br>maak dan onder <a href="/organisation/settings">instellingen</a> eerst een vestiging aan. */
  location?: number | null;
  assigned_to?: number | null;
  invoice?: number | null;
  period_job?: number | null;
  invited?: number[];
  rejected?: number[];
  interested?: number[];
}

export interface SDBJobs {
  sdb_job_id?: string | null;
  /** Kies de organisatie */
  organisation: number;
  title: string;
  /** Vul de datum in (bijv. 2017-10-21) */
  date: string;
  /** Vul de starttijd in (bijv. 10:00) */
  start: string;
  end: string;
  pause: number;
  function: string;
  address: string;
  postal_code: string;
  city: string;
}

export interface OrganisationAddSDBCredentials {
  sdb_api_key: string;
  sdb_account_name: string;
}

export type RateRuleCompetence =
  typeof RateRuleCompetence[keyof typeof RateRuleCompetence];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RateRuleCompetence = {
  baby: 'baby',
  dreumes: 'dreumes',
  peuter: 'peuter',
  verticaal: 'verticaal',
  speelzaal: 'speelzaal',
  bso: 'bso',
  vve: 'vve',
  pedagoog: 'pedagoog',
  pbgl: 'pbgl',
  wbgl: 'wbgl',
  abgl: 'abgl',
  kantoor: 'kantoor',
  lvd: 'lvd',
} as const;

export interface RateRule {
  competence?: RateRuleCompetence;
  rate: number;
  rate_exempt: number;
}

export interface OrganisationLocationRateRule {
  locations: OrganisationJobsLocation[];
  rate_rules: RateRule[];
}

export interface OrganisationDetails {
  readonly id?: number;
  company_name: string;
  hq_address?: string | null;
  hq_postal_code?: string | null;
  hq_city?: string | null;
  phone_number: string;
}

export interface PeriodJobInvitedFreelancer {
  from_date: string;
  to_date: string;
  accepted: number;
  refused: number;
  pending: number;
  sub_total: number;
  is_urgent: boolean;
  freelancer: User;
  accepted_by: User;
}

export interface PeriodJobAssignmentDetails {
  id: number;
  invited_freelancers: PeriodJobInvitedFreelancer[];
  assignments: DerivedJobAd[];
  number_accepted: number;
  number_cancelled: number;
  number_expired: number;
  number_pending: number;
  number_refused: number;
}

export interface PeriodJobInterestedUsers {
  user_id: number;
  city: string;
  readonly picture?: string;
  rate: string;
  name: string;
  freelancer_id: number;
  vat_exempt: boolean;
  readonly avg_rating?: number;
}

export interface OrganisationPeriodJobDetails {
  readonly id?: number;
  readonly organisation?: string;
  readonly location?: string;
  readonly full_address?: string;
  from_date: string;
  to_date: string;
  start_time: string;
  end_time: string;
  /** Vul het aantal minuten pauze in */
  pause: number;
  readonly weekdays?: string[];
  readonly competence?: string;
  readonly certificates?: string[];
  /** Maximaal uurtarief wat jullie willen betalen (Excl BTW) */
  max_rate?: number | null;
  readonly max_rate_incl?: number;
  readonly max_rate_exempt?: number;
  remarks?: string | null;
  readonly actual_rate_exempt?: number;
  readonly number_interested?: string;
  status: string;
  is_confirmed: boolean;
  readonly interested_freelancers?: PeriodJobInterestedUsers[];
  readonly weekdays_in?: string;
}

export interface OrganisationPeriodJob {
  readonly id?: number;
  readonly organisation?: string;
  readonly location?: string;
  readonly full_address?: string;
  from_date: string;
  to_date: string;
  readonly weekdays_in?: string;
  start_time: string;
  end_time: string;
  /** Vul het aantal minuten pauze in */
  pause: number;
  readonly weekdays?: string[];
  readonly competence?: string;
  readonly certificates?: string[];
  /** Maximaal uurtarief wat jullie willen betalen (Excl BTW) */
  max_rate?: number | null;
  readonly max_rate_incl?: number;
  readonly max_rate_exempt?: number;
  remarks?: string | null;
  readonly actual_rate_exempt?: number;
  readonly number_interested?: string;
  status: string;
  is_confirmed: boolean;
}

export interface OrganisationJobInvitedUsers {
  readonly id?: number;
  name: string;
  readonly freelancer_id?: number;
}

export interface OrganisationJobInvoice {
  title: string;
  invoice_number: string;
  invoice_date: string;
  readonly invoice_period?: string;
  readonly invoice_vat?: string;
  readonly file?: string;
}

export interface OrganisationJobsAssignedTo {
  readonly id?: number;
  name: string;
}

export interface OrganisationJobsLocation {
  readonly id?: number;
  readonly name?: string;
}

export interface OrganisationJobsOrganisation {
  readonly id?: number;
  name: string;
}

export interface DerivedJobAd {
  readonly id?: number;
  /** Vul de datum in (bijv. 2017-10-21) */
  date: string;
  /** Vul de starttijd in (bijv. 10:00) */
  start: string;
  /** Vul de eindtijd in (bijv. 18:30) */
  end: string;
  /** Vul het aantal minuten pauze in */
  pause: number;
  location: OrganisationJobsLocation;
  assigned_to: OrganisationJobsAssignedTo;
  readonly competence?: string;
  readonly created_at?: string;
  organisation: OrganisationJobsOrganisation;
  /** Opmerkingen over de opdracht (optioneel) */
  remarks?: string | null;
  accept_now?: boolean;
  invite_only?: boolean;
  readonly is_personal?: boolean;
  readonly is_urgent?: boolean;
  readonly is_favorite?: boolean;
  readonly is_location_favorite?: boolean;
  readonly is_blacklisted?: boolean;
  readonly is_blacklisted_by_location?: boolean;
  readonly is_vat_exempt?: boolean;
  readonly hours?: string;
  readonly invited_users?: OrganisationJobInvitedUsers[];
  readonly rejected_users?: OrganisationJobInvitedUsers[];
  readonly accepted?: boolean;
  readonly refused?: boolean;
  readonly pending?: boolean;
  readonly converted?: boolean;
  readonly expired?: boolean;
  readonly cancelled?: boolean;
}

export interface OrganisationJobDetails {
  readonly id?: number;
  /** Vul de datum in (bijv. 2017-10-21) */
  date: string;
  /** Vul de starttijd in (bijv. 10:00) */
  start: string;
  /** Vul de eindtijd in (bijv. 18:30) */
  end: string;
  /** Vul het aantal minuten pauze in */
  pause: number;
  location: OrganisationJobsLocation;
  assigned_to: OrganisationJobsAssignedTo;
  readonly competence?: string;
  readonly created_at?: string;
  organisation: OrganisationJobsOrganisation;
  /** Opmerkingen over de opdracht (optioneel) */
  remarks?: string | null;
  accept_now?: boolean;
  invite_only?: boolean;
  readonly is_personal?: string;
  readonly is_urgent?: string;
  readonly is_interest?: string;
  readonly is_favorite?: boolean;
  readonly is_location_favorite?: boolean;
  readonly is_blacklisted?: boolean;
  readonly is_blacklisted_by_location?: boolean;
  /** Uurtarief (Excl BTW) */
  rate?: number | null;
  readonly rate_incl?: number;
  /** Uurtarief (Vrijgesteld) */
  rate_exempt?: number | null;
  /** Maximaal uurtarief wat jullie willen betalen (Excl BTW) */
  max_rate?: number | null;
  readonly max_rate_incl?: number;
  /** Maximaal uurtarief wat jullie willen betalen (Vrijgesteld) */
  max_rate_exempt?: number | null;
  readonly actual_rate?: string;
  readonly is_vat_exempt?: string;
  readonly hours?: string;
  readonly total?: string;
  readonly total_vat?: string;
  readonly total_incl?: string;
  invoice: OrganisationJobInvoice;
  readonly invited_users?: OrganisationJobInvitedUsers[];
  readonly interested_users?: OrganisationJobInvitedUsers[];
}

export interface OrganisationJobs {
  readonly id?: number;
  organisation: OrganisationJobsOrganisation;
  location: OrganisationJobsLocation;
  /** Vul de datum in (bijv. 2017-10-21) */
  date: string;
  /** Vul de starttijd in (bijv. 10:00) */
  start: string;
  /** Vul de eindtijd in (bijv. 18:30) */
  end: string;
  /** Vul het aantal minuten pauze in */
  pause: number;
  readonly competence?: string;
  /** Uurtarief (Excl BTW) */
  rate?: number | null;
  readonly rate_incl?: number;
  /** Uurtarief (Vrijgesteld) */
  rate_exempt?: number | null;
  /** Maximaal uurtarief wat jullie willen betalen (Excl BTW) */
  max_rate?: number | null;
  readonly max_rate_incl?: number;
  /** Maximaal uurtarief wat jullie willen betalen (Vrijgesteld) */
  max_rate_exempt?: number | null;
  /** Opmerkingen over de opdracht (optioneel) */
  remarks?: string | null;
  assigned_to: OrganisationJobsAssignedTo;
  readonly is_personal?: boolean;
  readonly is_urgent?: boolean;
  readonly is_interest?: boolean;
  readonly is_favorite?: boolean;
  readonly is_location_favorite?: boolean;
  readonly is_blacklisted?: boolean;
  readonly is_blacklisted_by_location?: boolean;
  accept_now?: boolean;
  invite_only?: boolean;
  readonly actual_rate?: number;
  readonly is_vat_exempt?: boolean;
  readonly is_interest_shown?: boolean;
}

export interface FreelancerDetail {
  readonly user_id?: number;
  readonly freelancer_id?: number;
  readonly name?: string;
  readonly email?: string;
  phone_number?: string | null;
  /** Een KvK-nummer bestaat uit 8 cijfers */
  kvk_nummer?: string | null;
  readonly city?: string;
  readonly picture?: string;
  readonly thumbnail?: string;
  average_rating?: string;
  rate?: number;
  /** Plaats hier een leuke, informele profiel tekst */
  about?: string | null;
  readonly vat_choice?: string;
  readonly is_favorite?: string;
  competences: string[];
  certificates: string[];
  documents: Document[];
  readonly reviews_count?: string;
}

export interface FreelancerAvailability {
  date: string;
  start?: string | null;
  end?: string | null;
  available: boolean;
}

export interface EditDerivedJob {
  /** Vul de starttijd in (bijv. 10:00) */
  start: string;
  /** Vul de eindtijd in (bijv. 18:30) */
  end: string;
  /** Vul het aantal minuten pauze in */
  pause: number;
}

export interface ContractRequest {
  readonly id?: number;
  user?: number;
  from_date: string;
  to_date: string;
  readonly date?: string;
  readonly completed?: boolean;
}

export interface FavoritesAndBlockedAction {
  /** User id of freelancer */
  user: number;
}

export interface UserList {
  readonly id?: number;
  readonly picture?: string;
  readonly thumbnail?: string;
  first_name?: string;
  last_name?: string;
  readonly phone_number?: string;
  email?: string;
}

export interface OrganisationAdminDetails {
  readonly id?: number;
  readonly check_personenregister?: string;
  company_name: string;
  /** Bedrijfs Logo */
  readonly logo?: string | null;
  /** SDB API Key added status */
  readonly sdb_status?: boolean;
}

export type NotificationPreferencesReceiveFrequency =
  typeof NotificationPreferencesReceiveFrequency[keyof typeof NotificationPreferencesReceiveFrequency];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationPreferencesReceiveFrequency = {
  '1': 1,
  '2': 2,
} as const;

export interface NotificationPreferences {
  readonly id?: number;
  receive_by_email?: boolean;
  receive_by_push?: boolean;
  receive_frequency?: NotificationPreferencesReceiveFrequency;
}

export interface Notification {
  readonly id?: number;
  readonly type?: string;
  message?: string | null;
  readonly timestamp?: string;
}

export interface ChangePassword {
  old_password: string;
  password: string;
  password2: string;
}

export interface User {
  readonly id?: number;
  readonly freelancer_id?: number;
  /** Vereist. 150 tekens of minder. Alleen letters, cijfers en @/,/+/-/_ tekens zijn toegestaan. */
  username: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  readonly picture?: string;
  readonly is_freelancer?: boolean;
  readonly is_organisation_admin?: boolean;
  /** Bepaalt of de gebruiker kan inloggen op deze beheersite. */
  readonly is_staff?: boolean;
}

/**
 * Module
 */
export type PropertyModule = typeof PropertyModule[keyof typeof PropertyModule];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyModule = {
  exact: 'exact',
  migration: 'migration',
} as const;

export interface Property {
  /** Module */
  module: PropertyModule;
  name: string;
  value: string;
}

export interface LocationDetails {
  readonly id?: number;
  name: string;
  /** Straat en huisnummer (+toevoegingen) */
  address: string;
  postal_code: string;
  city: string;
  phone_number?: string | null;
}

export interface AvailableJobAd {
  readonly id?: number;
  readonly organisation?: string;
  readonly location?: string;
  readonly parking_free?: string;
  readonly full_address?: string;
  readonly lat_lon?: string;
  /** Vul de datum in (bijv. 2017-10-21) */
  date: string;
  /** Vul de starttijd in (bijv. 10:00) */
  start: string;
  /** Vul de eindtijd in (bijv. 18:30) */
  end: string;
  /** Vul het aantal minuten pauze in */
  pause: number;
  readonly competence?: string;
  readonly certificates?: string[];
  readonly actual_rate?: number;
  readonly actual_rate_incl?: number;
  readonly actual_rate_exempt?: number;
  /** Maximaal uurtarief wat jullie willen betalen (Excl BTW) */
  max_rate?: number | null;
  readonly max_rate_incl?: number;
  /** Maximaal uurtarief wat jullie willen betalen (Vrijgesteld) */
  max_rate_exempt?: number | null;
  /** Opmerkingen over de opdracht (optioneel) */
  remarks?: string | null;
  readonly travel_distance?: number;
  accept_now?: boolean;
  readonly is_interested?: boolean;
  readonly is_personal?: boolean;
  readonly is_interest?: boolean;
  readonly is_urgent?: boolean;
  worked_start?: string | null;
  worked_end?: string | null;
  worked_pause?: number | null;
  readonly organisation_phone?: string;
  readonly location_phone?: string;
  readonly location_remarks?: string;
  readonly is_vat_exempt?: boolean;
  readonly is_derived?: boolean;
  readonly is_available?: boolean;
}

export type JobRejectType = typeof JobRejectType[keyof typeof JobRejectType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobRejectType = {
  reject: 'reject',
  mutual: 'mutual',
} as const;

export interface JobReject {
  reason?: string;
  type?: JobRejectType;
}

export interface Reason {
  reason?: string;
}

export interface JobHours {
  worked_start: string;
  worked_end: string;
  worked_pause: number;
}

/**
 * Benodigde competentie
 */
export type JobAdEditCompetence =
  typeof JobAdEditCompetence[keyof typeof JobAdEditCompetence];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAdEditCompetence = {
  baby: 'baby',
  dreumes: 'dreumes',
  peuter: 'peuter',
  verticaal: 'verticaal',
  speelzaal: 'speelzaal',
  bso: 'bso',
  vve: 'vve',
  pedagoog: 'pedagoog',
  pbgl: 'pbgl',
  wbgl: 'wbgl',
  abgl: 'abgl',
  kantoor: 'kantoor',
  lvd: 'lvd',
} as const;

export interface JobAdEdit {
  /** Kies de vestiging waar u een invaller nodig heeft. Is de lijst leeg,<br>maak dan onder <a href="/organisation/settings">instellingen</a> eerst een vestiging aan. */
  location?: number | null;
  /** Benodigde competentie */
  competence: JobAdEditCompetence;
  /** Vul de starttijd in (bijv. 10:00) */
  start: string;
  /** Vul de eindtijd in (bijv. 18:30) */
  end: string;
  /** Vul het aantal minuten pauze in */
  pause: number;
  /** Opmerkingen over de opdracht (optioneel) */
  remarks?: string | null;
  invited?: number[];
  invite_only?: boolean;
  /** Uurtarief (Excl BTW) */
  rate?: number | null;
  /** Uurtarief (Vrijgesteld) */
  rate_exempt?: number | null;
  /** Maximaal uurtarief wat jullie willen betalen (Excl BTW) */
  max_rate?: number | null;
  /** Maximaal uurtarief wat jullie willen betalen (Vrijgesteld) */
  max_rate_exempt?: number | null;
  readonly is_assigned?: string;
  readonly is_vat_exempt?: string;
}

export interface JobAd {
  readonly id?: number;
  readonly organisation?: string;
  readonly organisation_kvk?: string;
  readonly location?: string;
  readonly location_phone?: string;
  readonly full_address?: string;
  readonly lat_lon?: string;
  /** Vul de datum in (bijv. 2017-10-21) */
  date: string;
  /** Vul de starttijd in (bijv. 10:00) */
  start: string;
  /** Vul de eindtijd in (bijv. 18:30) */
  end: string;
  /** Vul het aantal minuten pauze in */
  pause: number;
  readonly competence?: string;
  /** Uurtarief (Excl BTW) */
  rate?: number | null;
  readonly rate_incl?: number;
  /** Uurtarief (Vrijgesteld) */
  rate_exempt?: number | null;
  /** Opmerkingen over de opdracht (optioneel) */
  remarks?: string | null;
  readonly travel_distance?: number;
  accept_now?: boolean;
  readonly is_interested?: boolean;
  readonly is_personal?: boolean;
  readonly is_urgent?: boolean;
  readonly is_interest?: boolean;
  worked_start?: string | null;
  worked_end?: string | null;
  worked_pause?: number | null;
  readonly organisation_phone?: string;
  readonly location_remarks?: string;
  readonly switch_link?: string;
  readonly is_vat_exempt?: boolean;
  readonly is_derived?: boolean;
}

export interface JobCancel {
  reason?: string;
}

export interface Warnings {
  readonly success?: string;
  warnings: string[];
}

export interface AssignJobParam {
  freelancer: number;
  /** Used when assigning a job despite warnings. */
  force?: boolean;
}

export interface BulkJobCancel {
  reason?: string;
  /** List of JobAd ids. */
  jobs: number[];
}

export type InvoiceSummaryInvoiceVat =
  typeof InvoiceSummaryInvoiceVat[keyof typeof InvoiceSummaryInvoiceVat];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceSummaryInvoiceVat = {
  '3': 3,
  '2': 2,
  '1': 1,
} as const;

export type InvoiceSummaryInvoicePeriod =
  typeof InvoiceSummaryInvoicePeriod[keyof typeof InvoiceSummaryInvoicePeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceSummaryInvoicePeriod = {
  '7': 7,
  '14': 14,
  '21': 21,
  '30': 30,
} as const;

export interface InvoiceSummary {
  readonly id?: number;
  readonly organisation?: string;
  readonly location?: string;
  title: string;
  invoice_date: string;
  readonly expiry_date?: string;
  invoice_number: string;
  invoice_period: InvoiceSummaryInvoicePeriod;
  invoice_vat: InvoiceSummaryInvoiceVat;
  sent?: boolean;
  reminder_sent_at?: string | null;
  total?: number;
  readonly total_vat?: string;
  readonly total_incl?: string;
}

export interface OutstandingInvoiceWarning {
  warning: string;
}

export type InvoiceInvoiceVat =
  typeof InvoiceInvoiceVat[keyof typeof InvoiceInvoiceVat];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceInvoiceVat = {
  '3': 3,
  '2': 2,
  '1': 1,
} as const;

export type InvoiceInvoicePeriod =
  typeof InvoiceInvoicePeriod[keyof typeof InvoiceInvoicePeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceInvoicePeriod = {
  '7': 7,
  '14': 14,
  '21': 21,
  '30': 30,
} as const;

export interface InvoiceJob {
  readonly id?: number;
  readonly organisation?: string;
  readonly location?: string;
  readonly full_address?: string;
  readonly competence?: string;
  /** Vul de datum in (bijv. 2017-10-21) */
  date: string;
  readonly hours?: number;
  readonly rate?: number;
  readonly rate_incl?: number;
  readonly rate_exempt?: number;
  readonly actual_rate?: number;
  readonly is_vat_exempt?: string;
  readonly total?: number;
  readonly total_vat?: string;
  readonly total_incl?: number;
}

export interface Invoice {
  readonly id?: number;
  readonly organisation?: string;
  readonly location?: string;
  title: string;
  invoice_date: string;
  readonly expiry_date?: string;
  invoice_number: string;
  invoice_period: InvoiceInvoicePeriod;
  invoice_vat: InvoiceInvoiceVat;
  sent?: boolean;
  readonly file?: string;
  jobs: InvoiceJob[];
  total?: number;
  readonly total_vat?: string;
  readonly total_incl?: string;
  readonly total_exempt?: string;
}

export interface OutstandingInvoiceCreateParams {
  organisation: number;
  location?: number | null;
  invoice_title: string;
  invoice_number: string;
}

export interface Failure {
  readonly success?: string;
  errors: string[];
}

export interface KVKGeoLocation {
  type: string;
  coordinates: number[];
}

export interface KVKAddress {
  raw_address?: string | null;
  geo_location?: KVKGeoLocation;
  street_name?: string | null;
  house_number_extension?: string | null;
  house_number?: number | null;
  city?: string | null;
  postal_code?: string | null;
}

export interface KVKDetails {
  company_names: string[];
  sbi_codes: string[];
  addresses?: KVKAddress[];
}

/**
 * Geef aan of je btw-plichtig bent
 */
export type AvailableFreelancersBtwKeuze =
  typeof AvailableFreelancersBtwKeuze[keyof typeof AvailableFreelancersBtwKeuze];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvailableFreelancersBtwKeuze = {
  '3': 3,
  '2': 2,
} as const;

export interface AvailableFreelancers {
  readonly id?: number;
  readonly name?: string;
  readonly picture?: string;
  readonly city?: string;
  /** Geef aan in welk jaar u begon te werken */
  experience?: number | null;
  /** Plaats hier een leuke, informele profiel tekst */
  about?: string | null;
  competences: string[];
  readonly rate_excl?: number;
  readonly vat?: number;
  readonly rate_incl?: number;
  readonly travel_distance?: number;
  active_bonus?: string;
  verified_at?: string | null;
  readonly sickdays?: number;
  readonly avg_rating?: number;
  readonly favorite?: number;
  diplomas: string[];
  /** Geef aan of je btw-plichtig bent */
  btw_keuze?: AvailableFreelancersBtwKeuze;
}

export interface AvailableFreelancersResponse {
  freelancers: AvailableFreelancers[];
}

export interface CompetenceChoices {
  code: string;
  name: string;
}

export type AccountDeleteReason =
  typeof AccountDeleteReason[keyof typeof AccountDeleteReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountDeleteReason = {
  Nieuwe_baan: 'Nieuwe baan',
  Te_weinig_diensten: 'Te weinig diensten',
  Te_lage_uurtarieven: 'Te lage uurtarieven',
  Lastige_betaling: 'Lastige betaling',
  Te_veel_onzekerheid: 'Te veel onzekerheid',
  Anders: 'Anders...',
} as const;

export interface AccountDelete {
  reason: AccountDeleteReason;
  other_reason?: string;
}

export type FreelancerCompetences = { [key: string]: boolean };

/**
 * Geef aan of je btw-plichtig bent
 */
export type FreelancerBtwKeuze =
  typeof FreelancerBtwKeuze[keyof typeof FreelancerBtwKeuze];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FreelancerBtwKeuze = {
  '3': 3,
  '2': 2,
} as const;

export interface Freelancer {
  readonly id?: number;
  first_name: string;
  last_name: string;
  phone_number?: string | null;
  email: string;
  /** Een KvK-nummer bestaat uit 8 cijfers */
  kvk_nummer?: string | null;
  /** Bijvoorbeeld NL02ABNA0123456789 */
  rekening_nummer?: string | null;
  /** Bijvoorbeeld NL0007891234B01 */
  btw_nummer?: string | null;
  rate?: number;
  birthday?: string | null;
  /** <ul><li>Je BSN nummer wordt alleen gebruikt voor de koppeling in het personenregister, alleen door opdrachtgevers waarmee wij een speciale verwerkingsovereenkomst hebben.</li><li>Het BSN nummer wordt enkel doorgegeven aan opdrachtgevers waarmee een specialeovereenkomst is getekend, deze opdrachtgevers gebruiken het BSN nummer voor koppeling in het personenregister.</li></ul> */
  bsn?: string | null;
  /** Plaats hier een leuke, informele profiel tekst */
  about?: string | null;
  /** Geef aan of je btw-plichtig bent */
  btw_keuze?: FreelancerBtwKeuze;
  readonly picture?: string;
  readonly thumbnail?: string;
  readonly profile_picture_request?: string | null;
  profile_picture_request_date?: string | null;
  /** Naam van je onderneming bij de Kamer van Koophandel */
  company_name?: string | null;
  /** Ik heb alle documenten van de freelancer gecontroleerd op correctheid en verleen hierbij toegang tot het platform. */
  verified?: boolean;
  /** Deze freelancer heeft de aanmeldflow uitgevoerd en kan geverifieerd worden. */
  ready_for_verification?: boolean;
  /** Geef aan of je een rijbewijs hebt. */
  has_driver_license?: boolean;
  /** Geef aan of je een stintbewijs hebt. */
  has_stint_license?: boolean;
  sbi_codes?: string | null;
  addresses?: Address[];
  competences?: FreelancerCompetences;
}

export type AddressAddressType =
  typeof AddressAddressType[keyof typeof AddressAddressType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddressAddressType = {
  Home: 'Home',
  Work: 'Work',
  Other: 'Other',
} as const;

export interface Address {
  id?: string;
  address_type: AddressAddressType;
  address_name?: string;
  readonly raw_address?: string;
  street_name: string;
  house_number?: string | null;
  house_number_extension?: string | null;
  postal_code: string;
  city: string;
  geo_location?: string | null;
}

export interface DocumentTypeDetails {
  readonly id?: number;
  name: string;
  readonly allows_baby?: boolean;
  readonly allows_dreumes?: boolean;
  readonly allows_peuter?: boolean;
  readonly allows_verticaal?: boolean;
  readonly allows_speelzaal?: boolean;
  readonly allows_bso?: boolean;
  readonly allows_vve?: boolean;
  readonly allows_pedagoog?: boolean;
  readonly allows_pbgl?: boolean;
  readonly allows_wbgl?: boolean;
  readonly allows_abgl?: boolean;
}

export interface DocumentUpdateRequest {
  readonly id?: number;
  freelancer?: number;
  dtype: number;
  update_reason: string;
  readonly thumbnail?: string;
  readonly picture?: string;
  readonly pdf?: string;
  valid_until?: string | null;
}

export interface Document {
  readonly id?: number;
  freelancer?: number;
  dtype: number;
  readonly name?: string;
  readonly thumbnail?: string;
  readonly picture?: string;
  readonly pdf?: string;
  readonly verified?: boolean;
  valid_until?: string | null;
  readonly is_diploma?: boolean;
  readonly is_certificate?: boolean;
}

export type FCMDeviceType = typeof FCMDeviceType[keyof typeof FCMDeviceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FCMDeviceType = {
  ios: 'ios',
  android: 'android',
  web: 'web',
} as const;

export interface FCMDevice {
  readonly id?: number;
  name?: string | null;
  registration_id: string;
  /** Unique device identifier */
  device_id?: string | null;
  /** Inactive devices will not be sent notifications */
  active?: boolean;
  readonly date_created?: string;
  type: FCMDeviceType;
}

export interface AvailableDay {
  date: string;
  start?: string | null;
  end?: string | null;
  available: boolean;
}

export interface AvailableDays {
  days: AvailableDay[];
  repeat: boolean;
  repeat_end?: string | null;
}

export interface Success {
  readonly success?: string;
}

export interface AutoCompleteOrganisation {
  /** Id of the organisation. */
  value: number;
  /** Company name of the organisation. */
  text: string;
}

export interface AutoCompleteLocation {
  /** Id of the location. */
  value: number;
  /** Name of the location. */
  text: string;
}

export interface AutoCompleteFreelancer {
  /** Id of the freelancer. */
  value: number;
  /** Name of the freelancer. */
  text: string;
}

export interface AutoCompleteFreelancerUser {
  /** Id of the user. */
  value: number;
  /** Name of the user. */
  text: string;
}

export interface DocumentType {
  readonly id?: number;
  name: string;
  is_diploma?: boolean;
  is_certificate?: boolean;
  require_validation_date?: boolean;
}

export interface AutoCompleteAssignees {
  /** User id of the assignee */
  value: number;
  /** Name of the user assignee. */
  text: string;
}

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Get list of assigned freelancer to JobAd for the organisation.
 * @summary Autocomplete Assignees API
 */
export const apiAutocompleteAssigneesList = (
  params?: ApiAutocompleteAssigneesListParams,
  signal?: AbortSignal,
) => {
  return customInstance<AutoCompleteAssignees[]>({
    url: `/api/autocomplete/assignees/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAutocompleteAssigneesListQueryKey = (
  params?: ApiAutocompleteAssigneesListParams,
) => [`/api/autocomplete/assignees/`, ...(params ? [params] : [])];

export type ApiAutocompleteAssigneesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAutocompleteAssigneesList>>
>;
export type ApiAutocompleteAssigneesListQueryError = ErrorType<unknown>;

export const useApiAutocompleteAssigneesList = <
  TData = Awaited<ReturnType<typeof apiAutocompleteAssigneesList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAutocompleteAssigneesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAutocompleteAssigneesList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiAutocompleteAssigneesListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAutocompleteAssigneesList>>
  > = ({ signal }) => apiAutocompleteAssigneesList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAutocompleteAssigneesList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * List of document types based on matching query
 * @summary Autocomplete Document Type API
 */
export const apiAutocompleteDocumentTypeList = (
  params?: ApiAutocompleteDocumentTypeListParams,
  signal?: AbortSignal,
) => {
  return customInstance<DocumentType[]>({
    url: `/api/autocomplete/document_type/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAutocompleteDocumentTypeListQueryKey = (
  params?: ApiAutocompleteDocumentTypeListParams,
) => [`/api/autocomplete/document_type/`, ...(params ? [params] : [])];

export type ApiAutocompleteDocumentTypeListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAutocompleteDocumentTypeList>>
>;
export type ApiAutocompleteDocumentTypeListQueryError = ErrorType<unknown>;

export const useApiAutocompleteDocumentTypeList = <
  TData = Awaited<ReturnType<typeof apiAutocompleteDocumentTypeList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAutocompleteDocumentTypeListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAutocompleteDocumentTypeList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiAutocompleteDocumentTypeListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAutocompleteDocumentTypeList>>
  > = ({ signal }) => apiAutocompleteDocumentTypeList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAutocompleteDocumentTypeList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * API to get list of verified and active users that are assignees in request user's organisation jobs.
 * @summary Autocomplete Freelancer User API
 */
export const apiAutocompleteFreelancersUsersList = (
  params?: ApiAutocompleteFreelancersUsersListParams,
  signal?: AbortSignal,
) => {
  return customInstance<AutoCompleteFreelancerUser[]>({
    url: `/api/autocomplete/freelancers-users/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAutocompleteFreelancersUsersListQueryKey = (
  params?: ApiAutocompleteFreelancersUsersListParams,
) => [`/api/autocomplete/freelancers-users/`, ...(params ? [params] : [])];

export type ApiAutocompleteFreelancersUsersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAutocompleteFreelancersUsersList>>
>;
export type ApiAutocompleteFreelancersUsersListQueryError = ErrorType<unknown>;

export const useApiAutocompleteFreelancersUsersList = <
  TData = Awaited<ReturnType<typeof apiAutocompleteFreelancersUsersList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAutocompleteFreelancersUsersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAutocompleteFreelancersUsersList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiAutocompleteFreelancersUsersListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAutocompleteFreelancersUsersList>>
  > = ({ signal }) => apiAutocompleteFreelancersUsersList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAutocompleteFreelancersUsersList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get list of freelancers matching to the query.
 * @summary Autocomplete Freelancers API
 */
export const apiAutocompleteFreelancersList = (
  params?: ApiAutocompleteFreelancersListParams,
  signal?: AbortSignal,
) => {
  return customInstance<AutoCompleteFreelancer[]>({
    url: `/api/autocomplete/freelancers/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAutocompleteFreelancersListQueryKey = (
  params?: ApiAutocompleteFreelancersListParams,
) => [`/api/autocomplete/freelancers/`, ...(params ? [params] : [])];

export type ApiAutocompleteFreelancersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAutocompleteFreelancersList>>
>;
export type ApiAutocompleteFreelancersListQueryError = ErrorType<unknown>;

export const useApiAutocompleteFreelancersList = <
  TData = Awaited<ReturnType<typeof apiAutocompleteFreelancersList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAutocompleteFreelancersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAutocompleteFreelancersList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiAutocompleteFreelancersListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAutocompleteFreelancersList>>
  > = ({ signal }) => apiAutocompleteFreelancersList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAutocompleteFreelancersList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get list of locations based on matching query.
 * @summary Autocomplete Locations API
 */
export const apiAutocompleteLocationsList = (
  params?: ApiAutocompleteLocationsListParams,
  signal?: AbortSignal,
) => {
  return customInstance<AutoCompleteLocation[]>({
    url: `/api/autocomplete/locations/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAutocompleteLocationsListQueryKey = (
  params?: ApiAutocompleteLocationsListParams,
) => [`/api/autocomplete/locations/`, ...(params ? [params] : [])];

export type ApiAutocompleteLocationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAutocompleteLocationsList>>
>;
export type ApiAutocompleteLocationsListQueryError = ErrorType<unknown>;

export const useApiAutocompleteLocationsList = <
  TData = Awaited<ReturnType<typeof apiAutocompleteLocationsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAutocompleteLocationsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAutocompleteLocationsList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiAutocompleteLocationsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAutocompleteLocationsList>>
  > = ({ signal }) => apiAutocompleteLocationsList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAutocompleteLocationsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get list of organisations matching to the query.
 * @summary Autocomplete Organisations API
 */
export const apiAutocompleteOrganisationsList = (
  params?: ApiAutocompleteOrganisationsListParams,
  signal?: AbortSignal,
) => {
  return customInstance<AutoCompleteOrganisation[]>({
    url: `/api/autocomplete/organisations/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAutocompleteOrganisationsListQueryKey = (
  params?: ApiAutocompleteOrganisationsListParams,
) => [`/api/autocomplete/organisations/`, ...(params ? [params] : [])];

export type ApiAutocompleteOrganisationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAutocompleteOrganisationsList>>
>;
export type ApiAutocompleteOrganisationsListQueryError = ErrorType<unknown>;

export const useApiAutocompleteOrganisationsList = <
  TData = Awaited<ReturnType<typeof apiAutocompleteOrganisationsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAutocompleteOrganisationsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAutocompleteOrganisationsList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiAutocompleteOrganisationsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAutocompleteOrganisationsList>>
  > = ({ signal }) => apiAutocompleteOrganisationsList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAutocompleteOrganisationsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * API to get all location(s) of the logged-in user, where user is admin of those locations.
 * @summary Autocomplete User's Locations API
 */
export const apiAutocompleteUserLocationsList = (
  params?: ApiAutocompleteUserLocationsListParams,
  signal?: AbortSignal,
) => {
  return customInstance<AutoCompleteLocation[]>({
    url: `/api/autocomplete/user/locations/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAutocompleteUserLocationsListQueryKey = (
  params?: ApiAutocompleteUserLocationsListParams,
) => [`/api/autocomplete/user/locations/`, ...(params ? [params] : [])];

export type ApiAutocompleteUserLocationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAutocompleteUserLocationsList>>
>;
export type ApiAutocompleteUserLocationsListQueryError = ErrorType<unknown>;

export const useApiAutocompleteUserLocationsList = <
  TData = Awaited<ReturnType<typeof apiAutocompleteUserLocationsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAutocompleteUserLocationsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAutocompleteUserLocationsList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiAutocompleteUserLocationsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAutocompleteUserLocationsList>>
  > = ({ signal }) => apiAutocompleteUserLocationsList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAutocompleteUserLocationsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * API to get all verified organisation(s) of the logged-in user, where user is admin of those organisations.
 * @summary Autocomplete User's Organisations API
 */
export const apiAutocompleteUserOrganisationsList = (
  params?: ApiAutocompleteUserOrganisationsListParams,
  signal?: AbortSignal,
) => {
  return customInstance<AutoCompleteOrganisation[]>({
    url: `/api/autocomplete/user/organisations/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAutocompleteUserOrganisationsListQueryKey = (
  params?: ApiAutocompleteUserOrganisationsListParams,
) => [`/api/autocomplete/user/organisations/`, ...(params ? [params] : [])];

export type ApiAutocompleteUserOrganisationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAutocompleteUserOrganisationsList>>
>;
export type ApiAutocompleteUserOrganisationsListQueryError = ErrorType<unknown>;

export const useApiAutocompleteUserOrganisationsList = <
  TData = Awaited<ReturnType<typeof apiAutocompleteUserOrganisationsList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiAutocompleteUserOrganisationsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAutocompleteUserOrganisationsList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiAutocompleteUserOrganisationsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAutocompleteUserOrganisationsList>>
  > = ({ signal }) => apiAutocompleteUserOrganisationsList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAutocompleteUserOrganisationsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get list of dates of available days for a freelancer
 * @summary Freelancer Available Days API
 */
export const apiAvailableList = (signal?: AbortSignal) => {
  return customInstance<string[]>({
    url: `/api/available/`,
    method: 'get',
    signal,
  });
};

export const getApiAvailableListQueryKey = () => [`/api/available/`];

export type ApiAvailableListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAvailableList>>
>;
export type ApiAvailableListQueryError = ErrorType<unknown>;

export const useApiAvailableList = <
  TData = Awaited<ReturnType<typeof apiAvailableList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiAvailableList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAvailableListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAvailableList>>
  > = ({ signal }) => apiAvailableList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAvailableList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Create available days for freelancer.
 * @summary Freelancer Create Available Days API
 */
export const apiAvailableAddCreate = (date: string) => {
  return customInstance<Success>({
    url: `/api/available/${date}/add/`,
    method: 'post',
  });
};

export type ApiAvailableAddCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAvailableAddCreate>>
>;

export type ApiAvailableAddCreateMutationError = ErrorType<unknown>;

export const useApiAvailableAddCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAvailableAddCreate>>,
    TError,
    { date: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAvailableAddCreate>>,
    { date: string }
  > = (props) => {
    const { date } = props ?? {};

    return apiAvailableAddCreate(date);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAvailableAddCreate>>,
    TError,
    { date: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Lets freelance remove/delete available days.
 * @summary Freelancer Remove Available Days API
 */
export const apiAvailableRemoveDelete = (date: string) => {
  return customInstance<Success>({
    url: `/api/available/${date}/remove/`,
    method: 'delete',
  });
};

export type ApiAvailableRemoveDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAvailableRemoveDelete>>
>;

export type ApiAvailableRemoveDeleteMutationError = ErrorType<unknown>;

export const useApiAvailableRemoveDelete = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAvailableRemoveDelete>>,
    TError,
    { date: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAvailableRemoveDelete>>,
    { date: string }
  > = (props) => {
    const { date } = props ?? {};

    return apiAvailableRemoveDelete(date);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAvailableRemoveDelete>>,
    TError,
    { date: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get freelancer's available days by week
 */
export const freelancerGetAvailableDaysByWeekAPI = (
  startOfWeek: string,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/api/available_days/week/${startOfWeek}/`,
    method: 'get',
    signal,
  });
};

export const getFreelancerGetAvailableDaysByWeekAPIQueryKey = (
  startOfWeek: string,
) => [`/api/available_days/week/${startOfWeek}/`];

export type FreelancerGetAvailableDaysByWeekAPIQueryResult = NonNullable<
  Awaited<ReturnType<typeof freelancerGetAvailableDaysByWeekAPI>>
>;
export type FreelancerGetAvailableDaysByWeekAPIQueryError = ErrorType<unknown>;

export const useFreelancerGetAvailableDaysByWeekAPI = <
  TData = Awaited<ReturnType<typeof freelancerGetAvailableDaysByWeekAPI>>,
  TError = ErrorType<unknown>,
>(
  startOfWeek: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof freelancerGetAvailableDaysByWeekAPI>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFreelancerGetAvailableDaysByWeekAPIQueryKey(startOfWeek);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof freelancerGetAvailableDaysByWeekAPI>>
  > = ({ signal }) => freelancerGetAvailableDaysByWeekAPI(startOfWeek, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof freelancerGetAvailableDaysByWeekAPI>>,
    TError,
    TData
  >(queryKey, queryFn, {
    enabled: !!startOfWeek,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Create freelancer available days by week
 */
export const freelancerCreateAvailableDaysByWeekAPI = (
  startOfWeek: string,
  availableDaysBody: AvailableDaysBody,
) => {
  return customInstance<Success>({
    url: `/api/available_days/week/${startOfWeek}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: availableDaysBody,
  });
};

export type FreelancerCreateAvailableDaysByWeekAPIMutationResult = NonNullable<
  Awaited<ReturnType<typeof freelancerCreateAvailableDaysByWeekAPI>>
>;
export type FreelancerCreateAvailableDaysByWeekAPIMutationBody =
  AvailableDaysBody;
export type FreelancerCreateAvailableDaysByWeekAPIMutationError =
  ErrorType<void>;

export const useFreelancerCreateAvailableDaysByWeekAPI = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof freelancerCreateAvailableDaysByWeekAPI>>,
    TError,
    { startOfWeek: string; data: AvailableDaysBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof freelancerCreateAvailableDaysByWeekAPI>>,
    { startOfWeek: string; data: AvailableDaysBody }
  > = (props) => {
    const { startOfWeek, data } = props ?? {};

    return freelancerCreateAvailableDaysByWeekAPI(startOfWeek, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof freelancerCreateAvailableDaysByWeekAPI>>,
    TError,
    { startOfWeek: string; data: AvailableDaysBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiDeviceCreate = (fCMDevice: FCMDevice) => {
  return customInstance<FCMDevice>({
    url: `/api/device/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: fCMDevice,
  });
};

export type ApiDeviceCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDeviceCreate>>
>;
export type ApiDeviceCreateMutationBody = FCMDevice;
export type ApiDeviceCreateMutationError = ErrorType<unknown>;

export const useApiDeviceCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDeviceCreate>>,
    TError,
    { data: FCMDevice },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDeviceCreate>>,
    { data: FCMDevice }
  > = (props) => {
    const { data } = props ?? {};

    return apiDeviceCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiDeviceCreate>>,
    TError,
    { data: FCMDevice },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Create document for freelancer
 * @summary Freelancer Document Create API
 */
export const apiDiplomaCreateCreate = (document: Document) => {
  return customInstance<Document>({
    url: `/api/diploma/create/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: document,
  });
};

export type ApiDiplomaCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDiplomaCreateCreate>>
>;
export type ApiDiplomaCreateCreateMutationBody = Document;
export type ApiDiplomaCreateCreateMutationError = ErrorType<unknown>;

export const useApiDiplomaCreateCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDiplomaCreateCreate>>,
    TError,
    { data: Document },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDiplomaCreateCreate>>,
    { data: Document }
  > = (props) => {
    const { data } = props ?? {};

    return apiDiplomaCreateCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiDiplomaCreateCreate>>,
    TError,
    { data: Document },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get a particular document of a freelancer.
 * @summary Freelancer Document Retrieve API
 */
export const apiDiplomaRead = (id: string, signal?: AbortSignal) => {
  return customInstance<Document>({
    url: `/api/diploma/${id}/`,
    method: 'get',
    signal,
  });
};

export const getApiDiplomaReadQueryKey = (id: string) => [
  `/api/diploma/${id}/`,
];

export type ApiDiplomaReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDiplomaRead>>
>;
export type ApiDiplomaReadQueryError = ErrorType<unknown>;

export const useApiDiplomaRead = <
  TData = Awaited<ReturnType<typeof apiDiplomaRead>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiDiplomaRead>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDiplomaReadQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDiplomaRead>>> = ({
    signal,
  }) => apiDiplomaRead(id, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiDiplomaRead>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Lets a freelancer delete a specific document.
 * @summary Freelancer Delete Document API
 */
export const apiDiplomaRemoveDelete = (id: string) => {
  return customInstance<void>({
    url: `/api/diploma/${id}/remove/`,
    method: 'delete',
  });
};

export type ApiDiplomaRemoveDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDiplomaRemoveDelete>>
>;

export type ApiDiplomaRemoveDeleteMutationError = ErrorType<unknown>;

export const useApiDiplomaRemoveDelete = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDiplomaRemoveDelete>>,
    TError,
    { id: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDiplomaRemoveDelete>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return apiDiplomaRemoveDelete(id);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiDiplomaRemoveDelete>>,
    TError,
    { id: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get list of document types
 * @summary Freelancer Document Types API
 */
export const apiDiplomaTypesList = (signal?: AbortSignal) => {
  return customInstance<DocumentType[]>({
    url: `/api/diploma_types/`,
    method: 'get',
    signal,
  });
};

export const getApiDiplomaTypesListQueryKey = () => [`/api/diploma_types/`];

export type ApiDiplomaTypesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDiplomaTypesList>>
>;
export type ApiDiplomaTypesListQueryError = ErrorType<unknown>;

export const useApiDiplomaTypesList = <
  TData = Awaited<ReturnType<typeof apiDiplomaTypesList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiDiplomaTypesList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDiplomaTypesListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiDiplomaTypesList>>
  > = ({ signal }) => apiDiplomaTypesList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiDiplomaTypesList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get list of documents of freelancer
 * @summary Freelancer Document API
 */
export const apiDiplomasList = (signal?: AbortSignal) => {
  return customInstance<Document[]>({
    url: `/api/diplomas/`,
    method: 'get',
    signal,
  });
};

export const getApiDiplomasListQueryKey = () => [`/api/diplomas/`];

export type ApiDiplomasListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDiplomasList>>
>;
export type ApiDiplomasListQueryError = ErrorType<unknown>;

export const useApiDiplomasList = <
  TData = Awaited<ReturnType<typeof apiDiplomasList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiDiplomasList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDiplomasListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDiplomasList>>> = ({
    signal,
  }) => apiDiplomasList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiDiplomasList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Lets freelancer create a request to update a document and notify freelancer about the same.
 * @summary Freelancer Request Document Update API
 */
export const apiDocumentRequestUpdateCreateCreate = (
  documentUpdateRequest: DocumentUpdateRequest,
) => {
  return customInstance<DocumentUpdateRequest>({
    url: `/api/document_request_update/create/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: documentUpdateRequest,
  });
};

export type ApiDocumentRequestUpdateCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentRequestUpdateCreateCreate>>
>;
export type ApiDocumentRequestUpdateCreateCreateMutationBody =
  DocumentUpdateRequest;
export type ApiDocumentRequestUpdateCreateCreateMutationError =
  ErrorType<unknown>;

export const useApiDocumentRequestUpdateCreateCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDocumentRequestUpdateCreateCreate>>,
    TError,
    { data: DocumentUpdateRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDocumentRequestUpdateCreateCreate>>,
    { data: DocumentUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiDocumentRequestUpdateCreateCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiDocumentRequestUpdateCreateCreate>>,
    TError,
    { data: DocumentUpdateRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get document type.
 * @summary Document Type Retrieve API
 */
export const apiDocumentTypeRead = (id: number, signal?: AbortSignal) => {
  return customInstance<DocumentTypeDetails>({
    url: `/api/document_type/${id}/`,
    method: 'get',
    signal,
  });
};

export const getApiDocumentTypeReadQueryKey = (id: number) => [
  `/api/document_type/${id}/`,
];

export type ApiDocumentTypeReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentTypeRead>>
>;
export type ApiDocumentTypeReadQueryError = ErrorType<unknown>;

export const useApiDocumentTypeRead = <
  TData = Awaited<ReturnType<typeof apiDocumentTypeRead>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiDocumentTypeRead>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDocumentTypeReadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiDocumentTypeRead>>
  > = ({ signal }) => apiDocumentTypeRead(id, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiDocumentTypeRead>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get list of document types
 * @summary Freelancer Document Types API
 */
export const apiDocumentTypesList = (signal?: AbortSignal) => {
  return customInstance<DocumentType[]>({
    url: `/api/document_types/`,
    method: 'get',
    signal,
  });
};

export const getApiDocumentTypesListQueryKey = () => [`/api/document_types/`];

export type ApiDocumentTypesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentTypesList>>
>;
export type ApiDocumentTypesListQueryError = ErrorType<unknown>;

export const useApiDocumentTypesList = <
  TData = Awaited<ReturnType<typeof apiDocumentTypesList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiDocumentTypesList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDocumentTypesListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiDocumentTypesList>>
  > = ({ signal }) => apiDocumentTypesList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiDocumentTypesList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * List of verified document types of the freelancer.
 * @summary Freelancer Verified Document Types API
 */
export const apiDocumentTypesVerifiedList = (signal?: AbortSignal) => {
  return customInstance<DocumentType[]>({
    url: `/api/document_types/verified/`,
    method: 'get',
    signal,
  });
};

export const getApiDocumentTypesVerifiedListQueryKey = () => [
  `/api/document_types/verified/`,
];

export type ApiDocumentTypesVerifiedListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDocumentTypesVerifiedList>>
>;
export type ApiDocumentTypesVerifiedListQueryError = ErrorType<unknown>;

export const useApiDocumentTypesVerifiedList = <
  TData = Awaited<ReturnType<typeof apiDocumentTypesVerifiedList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiDocumentTypesVerifiedList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiDocumentTypesVerifiedListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiDocumentTypesVerifiedList>>
  > = ({ signal }) => apiDocumentTypesVerifiedList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiDocumentTypesVerifiedList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Retrieve and Update freelancer details
 * @summary Freelancer Profile API
 */
export const apiFreelancerRead = (signal?: AbortSignal) => {
  return customInstance<Freelancer>({
    url: `/api/freelancer/`,
    method: 'get',
    signal,
  });
};

export const getApiFreelancerReadQueryKey = () => [`/api/freelancer/`];

export type ApiFreelancerReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFreelancerRead>>
>;
export type ApiFreelancerReadQueryError = ErrorType<unknown>;

export const useApiFreelancerRead = <
  TData = Awaited<ReturnType<typeof apiFreelancerRead>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiFreelancerRead>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFreelancerReadQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFreelancerRead>>
  > = ({ signal }) => apiFreelancerRead(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFreelancerRead>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Retrieve and Update freelancer details
 * @summary Freelancer Profile API
 */
export const apiFreelancerUpdate = (freelancerBody: FreelancerBody) => {
  return customInstance<Freelancer>({
    url: `/api/freelancer/`,
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    data: freelancerBody,
  });
};

export type ApiFreelancerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFreelancerUpdate>>
>;
export type ApiFreelancerUpdateMutationBody = FreelancerBody;
export type ApiFreelancerUpdateMutationError = ErrorType<unknown>;

export const useApiFreelancerUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFreelancerUpdate>>,
    TError,
    { data: FreelancerBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFreelancerUpdate>>,
    { data: FreelancerBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiFreelancerUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFreelancerUpdate>>,
    TError,
    { data: FreelancerBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Retrieve and Update freelancer details
 * @summary Freelancer Profile API
 */
export const apiFreelancerPartialUpdate = (freelancerBody: FreelancerBody) => {
  return customInstance<Freelancer>({
    url: `/api/freelancer/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/json' },
    data: freelancerBody,
  });
};

export type ApiFreelancerPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFreelancerPartialUpdate>>
>;
export type ApiFreelancerPartialUpdateMutationBody = FreelancerBody;
export type ApiFreelancerPartialUpdateMutationError = ErrorType<unknown>;

export const useApiFreelancerPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFreelancerPartialUpdate>>,
    TError,
    { data: FreelancerBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFreelancerPartialUpdate>>,
    { data: FreelancerBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiFreelancerPartialUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFreelancerPartialUpdate>>,
    TError,
    { data: FreelancerBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Delete Freelancer Account API
 */
export const freelancerDeleteAPI = (accountDelete: AccountDelete) => {
  return customInstance<Success>({
    url: `/api/freelancer/account/delete/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: accountDelete,
  });
};

export type FreelancerDeleteAPIMutationResult = NonNullable<
  Awaited<ReturnType<typeof freelancerDeleteAPI>>
>;
export type FreelancerDeleteAPIMutationBody = AccountDelete;
export type FreelancerDeleteAPIMutationError = ErrorType<void>;

export const useFreelancerDeleteAPI = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof freelancerDeleteAPI>>,
    TError,
    { data: AccountDelete },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof freelancerDeleteAPI>>,
    { data: AccountDelete }
  > = (props) => {
    const { data } = props ?? {};

    return freelancerDeleteAPI(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof freelancerDeleteAPI>>,
    TError,
    { data: AccountDelete },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Returns a dictionary of competence options for freelancers
 * @summary Freelancer Competence Options
 */
export const apiFreelancerCompetenceOptionsList = (signal?: AbortSignal) => {
  return customInstance<CompetenceChoices[]>({
    url: `/api/freelancer/competence-options/`,
    method: 'get',
    signal,
  });
};

export const getApiFreelancerCompetenceOptionsListQueryKey = () => [
  `/api/freelancer/competence-options/`,
];

export type ApiFreelancerCompetenceOptionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFreelancerCompetenceOptionsList>>
>;
export type ApiFreelancerCompetenceOptionsListQueryError = ErrorType<void>;

export const useApiFreelancerCompetenceOptionsList = <
  TData = Awaited<ReturnType<typeof apiFreelancerCompetenceOptionsList>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiFreelancerCompetenceOptionsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiFreelancerCompetenceOptionsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFreelancerCompetenceOptionsList>>
  > = ({ signal }) => apiFreelancerCompetenceOptionsList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFreelancerCompetenceOptionsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const apiFreelancerJobContractList = (
  jobId: string,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/api/freelancer/job/${jobId}/contract/`,
    method: 'get',
    signal,
  });
};

export const getApiFreelancerJobContractListQueryKey = (jobId: string) => [
  `/api/freelancer/job/${jobId}/contract/`,
];

export type ApiFreelancerJobContractListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFreelancerJobContractList>>
>;
export type ApiFreelancerJobContractListQueryError = ErrorType<unknown>;

export const useApiFreelancerJobContractList = <
  TData = Awaited<ReturnType<typeof apiFreelancerJobContractList>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFreelancerJobContractList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiFreelancerJobContractListQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFreelancerJobContractList>>
  > = ({ signal }) => apiFreelancerJobContractList(jobId, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFreelancerJobContractList>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!jobId, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get available freelancers for a specific organisation.
 * @summary Get Available freelancers
 */
export const apiFreelancersList = (
  params: ApiFreelancersListParams,
  signal?: AbortSignal,
) => {
  return customInstance<AvailableFreelancersResponse>({
    url: `/api/freelancers/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFreelancersListQueryKey = (
  params: ApiFreelancersListParams,
) => [`/api/freelancers/`, ...(params ? [params] : [])];

export type ApiFreelancersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFreelancersList>>
>;
export type ApiFreelancersListQueryError = ErrorType<unknown>;

export const useApiFreelancersList = <
  TData = Awaited<ReturnType<typeof apiFreelancersList>>,
  TError = ErrorType<unknown>,
>(
  params: ApiFreelancersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFreelancersList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiFreelancersListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFreelancersList>>
  > = ({ signal }) => apiFreelancersList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFreelancersList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Retrieve KvK details of a company using a kvk_number.
 * @summary Freelancer KVK API
 */
export const apiFreelancersKvkList = (
  params: ApiFreelancersKvkListParams,
  signal?: AbortSignal,
) => {
  return customInstance<KVKDetails>({
    url: `/api/freelancers/kvk/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFreelancersKvkListQueryKey = (
  params: ApiFreelancersKvkListParams,
) => [`/api/freelancers/kvk/`, ...(params ? [params] : [])];

export type ApiFreelancersKvkListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFreelancersKvkList>>
>;
export type ApiFreelancersKvkListQueryError = ErrorType<void>;

export const useApiFreelancersKvkList = <
  TData = Awaited<ReturnType<typeof apiFreelancersKvkList>>,
  TError = ErrorType<void>,
>(
  params: ApiFreelancersKvkListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFreelancersKvkList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiFreelancersKvkListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFreelancersKvkList>>
  > = ({ signal }) => apiFreelancersKvkList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFreelancersKvkList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Send Email to Freelancers for VOG
 * @summary Freelancer send VOG Email
 */
export const apiFreelancersVogCreate = () => {
  return customInstance<Success>({
    url: `/api/freelancers/vog/`,
    method: 'post',
  });
};

export type ApiFreelancersVogCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFreelancersVogCreate>>
>;

export type ApiFreelancersVogCreateMutationError = ErrorType<Failure>;

export const useApiFreelancersVogCreate = <
  TError = ErrorType<Failure>,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFreelancersVogCreate>>,
    TError,
    TVariables,
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFreelancersVogCreate>>,
    TVariables
  > = () => {
    return apiFreelancersVogCreate();
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFreelancersVogCreate>>,
    TError,
    TVariables,
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Create outstanding invoices of freelancer.
 * @summary Freelancer Outstanding Invoice API
 */
export const apiInvoiceCreateCreate = (
  outstandingInvoiceCreateParamsBody: OutstandingInvoiceCreateParamsBody,
) => {
  return customInstance<Invoice>({
    url: `/api/invoice/create/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: outstandingInvoiceCreateParamsBody,
  });
};

export type ApiInvoiceCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInvoiceCreateCreate>>
>;
export type ApiInvoiceCreateCreateMutationBody =
  OutstandingInvoiceCreateParamsBody;
export type ApiInvoiceCreateCreateMutationError =
  ErrorType<OutstandingInvoiceWarning>;

export const useApiInvoiceCreateCreate = <
  TError = ErrorType<OutstandingInvoiceWarning>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInvoiceCreateCreate>>,
    TError,
    { data: OutstandingInvoiceCreateParamsBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInvoiceCreateCreate>>,
    { data: OutstandingInvoiceCreateParamsBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiInvoiceCreateCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiInvoiceCreateCreate>>,
    TError,
    { data: OutstandingInvoiceCreateParamsBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Gives freelancer invoice number hints.
 * @summary Freelancer Invoice Number Hint API
 */
export const apiInvoiceHintList = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/api/invoice/hint/`,
    method: 'get',
    signal,
  });
};

export const getApiInvoiceHintListQueryKey = () => [`/api/invoice/hint/`];

export type ApiInvoiceHintListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInvoiceHintList>>
>;
export type ApiInvoiceHintListQueryError = ErrorType<unknown>;

export const useApiInvoiceHintList = <
  TData = Awaited<ReturnType<typeof apiInvoiceHintList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiInvoiceHintList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInvoiceHintListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiInvoiceHintList>>
  > = ({ signal }) => apiInvoiceHintList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiInvoiceHintList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Create outstanding invoices of freelancer.
 * @summary Freelancer Outstanding Invoice API
 */
export const apiInvoiceOutstandingCreateCreate = (
  outstandingInvoiceCreateParamsBody: OutstandingInvoiceCreateParamsBody,
) => {
  return customInstance<Invoice>({
    url: `/api/invoice/outstanding/create/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: outstandingInvoiceCreateParamsBody,
  });
};

export type ApiInvoiceOutstandingCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInvoiceOutstandingCreateCreate>>
>;
export type ApiInvoiceOutstandingCreateCreateMutationBody =
  OutstandingInvoiceCreateParamsBody;
export type ApiInvoiceOutstandingCreateCreateMutationError =
  ErrorType<OutstandingInvoiceWarning>;

export const useApiInvoiceOutstandingCreateCreate = <
  TError = ErrorType<OutstandingInvoiceWarning>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInvoiceOutstandingCreateCreate>>,
    TError,
    { data: OutstandingInvoiceCreateParamsBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInvoiceOutstandingCreateCreate>>,
    { data: OutstandingInvoiceCreateParamsBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiInvoiceOutstandingCreateCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiInvoiceOutstandingCreateCreate>>,
    TError,
    { data: OutstandingInvoiceCreateParamsBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get freelancer invoice details.
 * @summary Freelancer Invoice Details API
 */
export const apiInvoiceRead = (id: string, signal?: AbortSignal) => {
  return customInstance<Invoice>({
    url: `/api/invoice/${id}/`,
    method: 'get',
    signal,
  });
};

export const getApiInvoiceReadQueryKey = (id: string) => [
  `/api/invoice/${id}/`,
];

export type ApiInvoiceReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInvoiceRead>>
>;
export type ApiInvoiceReadQueryError = ErrorType<unknown>;

export const useApiInvoiceRead = <
  TData = Awaited<ReturnType<typeof apiInvoiceRead>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiInvoiceRead>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInvoiceReadQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInvoiceRead>>> = ({
    signal,
  }) => apiInvoiceRead(id, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiInvoiceRead>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Lets freelancer send reminder of an invoice sent.
 * @summary Freelancer Invoice Reminder API
 */
export const apiInvoiceReminderCreate = (id: string) => {
  return customInstance<Success>({
    url: `/api/invoice/${id}/reminder/`,
    method: 'post',
  });
};

export type ApiInvoiceReminderCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInvoiceReminderCreate>>
>;

export type ApiInvoiceReminderCreateMutationError = ErrorType<void>;

export const useApiInvoiceReminderCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInvoiceReminderCreate>>,
    TError,
    { id: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInvoiceReminderCreate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return apiInvoiceReminderCreate(id);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiInvoiceReminderCreate>>,
    TError,
    { id: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Lets freelancer send invoice to respective organisation.
 * @summary Freelancer Invoice Send API
 */
export const apiInvoiceSendCreate = (id: string) => {
  return customInstance<Success>({
    url: `/api/invoice/${id}/send/`,
    method: 'post',
  });
};

export type ApiInvoiceSendCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInvoiceSendCreate>>
>;

export type ApiInvoiceSendCreateMutationError = ErrorType<void>;

export const useApiInvoiceSendCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInvoiceSendCreate>>,
    TError,
    { id: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInvoiceSendCreate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return apiInvoiceSendCreate(id);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiInvoiceSendCreate>>,
    TError,
    { id: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Lets freelancer update the invoice.
 * @summary Freelancer Invoice Update API
 */
export const apiInvoiceUpdateCreate = (id: string) => {
  return customInstance<Invoice>({
    url: `/api/invoice/${id}/update/`,
    method: 'post',
  });
};

export type ApiInvoiceUpdateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInvoiceUpdateCreate>>
>;

export type ApiInvoiceUpdateCreateMutationError = ErrorType<void>;

export const useApiInvoiceUpdateCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInvoiceUpdateCreate>>,
    TError,
    { id: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInvoiceUpdateCreate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return apiInvoiceUpdateCreate(id);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiInvoiceUpdateCreate>>,
    TError,
    { id: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiInvoicesBilledList = (signal?: AbortSignal) => {
  return customInstance<InvoiceSummary[]>({
    url: `/api/invoices/billed/`,
    method: 'get',
    signal,
  });
};

export const getApiInvoicesBilledListQueryKey = () => [`/api/invoices/billed/`];

export type ApiInvoicesBilledListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInvoicesBilledList>>
>;
export type ApiInvoicesBilledListQueryError = ErrorType<unknown>;

export const useApiInvoicesBilledList = <
  TData = Awaited<ReturnType<typeof apiInvoicesBilledList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiInvoicesBilledList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInvoicesBilledListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiInvoicesBilledList>>
  > = ({ signal }) => apiInvoicesBilledList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiInvoicesBilledList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get freelancer open invoices.
 * @summary Freelancer Open Invoices API
 */
export const apiInvoicesOpenList = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/api/invoices/open/`,
    method: 'get',
    signal,
  });
};

export const getApiInvoicesOpenListQueryKey = () => [`/api/invoices/open/`];

export type ApiInvoicesOpenListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInvoicesOpenList>>
>;
export type ApiInvoicesOpenListQueryError = ErrorType<unknown>;

export const useApiInvoicesOpenList = <
  TData = Awaited<ReturnType<typeof apiInvoicesOpenList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiInvoicesOpenList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInvoicesOpenListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiInvoicesOpenList>>
  > = ({ signal }) => apiInvoicesOpenList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiInvoicesOpenList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const apiJobCreate = () => {
  return customInstance<void>({ url: `/api/job/`, method: 'post' });
};

export type ApiJobCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobCreate>>
>;

export type ApiJobCreateMutationError = ErrorType<unknown>;

export const useApiJobCreate = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobCreate>>,
    TError,
    TVariables,
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobCreate>>,
    TVariables
  > = () => {
    return apiJobCreate();
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobCreate>>,
    TError,
    TVariables,
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Lets an organisation cancel job ad(s) in bulk.

**Note**: In case of failure of validation(s) in any of the job(s), None of the job(s) will be cancelled.
 * @summary Organisation Bulk Cancel Job API
 */
export const apiJobBulkCancelCreate = (bulkJobCancel: BulkJobCancel) => {
  return customInstance<Success>({
    url: `/api/job/bulk/cancel/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: bulkJobCancel,
  });
};

export type ApiJobBulkCancelCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobBulkCancelCreate>>
>;
export type ApiJobBulkCancelCreateMutationBody = BulkJobCancel;
export type ApiJobBulkCancelCreateMutationError = ErrorType<void>;

export const useApiJobBulkCancelCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobBulkCancelCreate>>,
    TError,
    { data: BulkJobCancel },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobBulkCancelCreate>>,
    { data: BulkJobCancel }
  > = (props) => {
    const { data } = props ?? {};

    return apiJobBulkCancelCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobBulkCancelCreate>>,
    TError,
    { data: BulkJobCancel },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiJobConfirmCreate = (jobId: string, userId: string) => {
  return customInstance<void>({
    url: `/api/job/${jobId}/confirm/${userId}/`,
    method: 'post',
  });
};

export type ApiJobConfirmCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobConfirmCreate>>
>;

export type ApiJobConfirmCreateMutationError = ErrorType<unknown>;

export const useApiJobConfirmCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobConfirmCreate>>,
    TError,
    { jobId: string; userId: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobConfirmCreate>>,
    { jobId: string; userId: string }
  > = (props) => {
    const { jobId, userId } = props ?? {};

    return apiJobConfirmCreate(jobId, userId);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobConfirmCreate>>,
    TError,
    { jobId: string; userId: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Accept a job for freelancer.
 * @summary Freelancer Accept Job API
 */
export const apiJobAcceptCreate = (_var: string) => {
  return customInstance<Success>({
    url: `/api/job/${_var}/accept/`,
    method: 'post',
  });
};

export type ApiJobAcceptCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobAcceptCreate>>
>;

export type ApiJobAcceptCreateMutationError = ErrorType<void>;

export const useApiJobAcceptCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobAcceptCreate>>,
    TError,
    { _var: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobAcceptCreate>>,
    { _var: string }
  > = (props) => {
    const { _var } = props ?? {};

    return apiJobAcceptCreate(_var);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobAcceptCreate>>,
    TError,
    { _var: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * - While assigning a Job, there can be multiple warnings that are to be shown to organisation before they accept
  the freelancer for that job.
- Those warnings are to be displayed to Organisation. API will give `warnings` with success as `False` with `406`
  status code.
- To **override/force** assign after warnings, `force` parameter as `true` is to be passed.
  This would assign the job to freelancer despite the warnings.
 * @summary Organisation Assign Job to Freelancer.
 */
export const apiJobAssignCreate = (
  _var: string,
  assignJobParam: AssignJobParam,
) => {
  return customInstance<Success>({
    url: `/api/job/${_var}/assign/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: assignJobParam,
  });
};

export type ApiJobAssignCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobAssignCreate>>
>;
export type ApiJobAssignCreateMutationBody = AssignJobParam;
export type ApiJobAssignCreateMutationError = ErrorType<void | Warnings>;

export const useApiJobAssignCreate = <
  TError = ErrorType<void | Warnings>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobAssignCreate>>,
    TError,
    { _var: string; data: AssignJobParam },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobAssignCreate>>,
    { _var: string; data: AssignJobParam }
  > = (props) => {
    const { _var, data } = props ?? {};

    return apiJobAssignCreate(_var, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobAssignCreate>>,
    TError,
    { _var: string; data: AssignJobParam },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Lets an organisation cancel a specific Job ad.
 * @summary Organisation Cancel Job API
 */
export const apiJobCancelCreate = (_var: string, jobCancel: JobCancel) => {
  return customInstance<Success>({
    url: `/api/job/${_var}/cancel/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: jobCancel,
  });
};

export type ApiJobCancelCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobCancelCreate>>
>;
export type ApiJobCancelCreateMutationBody = JobCancel;
export type ApiJobCancelCreateMutationError = ErrorType<void>;

export const useApiJobCancelCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobCancelCreate>>,
    TError,
    { _var: string; data: JobCancel },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobCancelCreate>>,
    { _var: string; data: JobCancel }
  > = (props) => {
    const { _var, data } = props ?? {};

    return apiJobCancelCreate(_var, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobCancelCreate>>,
    TError,
    { _var: string; data: JobCancel },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get Job details for a particular job for Freelancer
 * @summary Freelancer Job Details API
 */
export const apiJobDetailsRead = (_var: string, signal?: AbortSignal) => {
  return customInstance<JobAd>({
    url: `/api/job/${_var}/details/`,
    method: 'get',
    signal,
  });
};

export const getApiJobDetailsReadQueryKey = (_var: string) => [
  `/api/job/${_var}/details/`,
];

export type ApiJobDetailsReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiJobDetailsRead>>
>;
export type ApiJobDetailsReadQueryError = ErrorType<void>;

export const useApiJobDetailsRead = <
  TData = Awaited<ReturnType<typeof apiJobDetailsRead>>,
  TError = ErrorType<void>,
>(
  _var: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiJobDetailsRead>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiJobDetailsReadQueryKey(_var);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiJobDetailsRead>>
  > = ({ signal }) => apiJobDetailsRead(_var, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiJobDetailsRead>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!_var, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Edit a job ad of an organisation.
 * @summary Organisation Edit Job API
 */
export const apiJobEditCreate = (_var: string, jobAdEdit: JobAdEdit) => {
  return customInstance<Success>({
    url: `/api/job/${_var}/edit/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: jobAdEdit,
  });
};

export type ApiJobEditCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobEditCreate>>
>;
export type ApiJobEditCreateMutationBody = JobAdEdit;
export type ApiJobEditCreateMutationError = ErrorType<void>;

export const useApiJobEditCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobEditCreate>>,
    TError,
    { _var: string; data: JobAdEdit },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobEditCreate>>,
    { _var: string; data: JobAdEdit }
  > = (props) => {
    const { _var, data } = props ?? {};

    return apiJobEditCreate(_var, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobEditCreate>>,
    TError,
    { _var: string; data: JobAdEdit },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Add job worked hours. Notify organisation with email if hours changed.
 * @summary Freelancer Job Hours API
 */
export const apiJobHoursCreate = (_var: string, jobHours: JobHours) => {
  return customInstance<Success>({
    url: `/api/job/${_var}/hours/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: jobHours,
  });
};

export type ApiJobHoursCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobHoursCreate>>
>;
export type ApiJobHoursCreateMutationBody = JobHours;
export type ApiJobHoursCreateMutationError = ErrorType<void>;

export const useApiJobHoursCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobHoursCreate>>,
    TError,
    { _var: string; data: JobHours },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobHoursCreate>>,
    { _var: string; data: JobHours }
  > = (props) => {
    const { _var, data } = props ?? {};

    return apiJobHoursCreate(_var, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobHoursCreate>>,
    TError,
    { _var: string; data: JobHours },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiJobInterestedCreate = (_var: string) => {
  return customInstance<void>({
    url: `/api/job/${_var}/interested/`,
    method: 'post',
  });
};

export type ApiJobInterestedCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobInterestedCreate>>
>;

export type ApiJobInterestedCreateMutationError = ErrorType<unknown>;

export const useApiJobInterestedCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobInterestedCreate>>,
    TError,
    { _var: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobInterestedCreate>>,
    { _var: string }
  > = (props) => {
    const { _var } = props ?? {};

    return apiJobInterestedCreate(_var);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobInterestedCreate>>,
    TError,
    { _var: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Lets an organisation mark JobAd assignee as NoShow when freelancer doesn't appear for that JobAd.
 * @summary Organisation NoShow Job API
 */
export const apiJobNoShowCreate = (_var: string, reason: Reason) => {
  return customInstance<Success>({
    url: `/api/job/${_var}/no-show/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: reason,
  });
};

export type ApiJobNoShowCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobNoShowCreate>>
>;
export type ApiJobNoShowCreateMutationBody = Reason;
export type ApiJobNoShowCreateMutationError = ErrorType<void>;

export const useApiJobNoShowCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobNoShowCreate>>,
    TError,
    { _var: string; data: Reason },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobNoShowCreate>>,
    { _var: string; data: Reason }
  > = (props) => {
    const { _var, data } = props ?? {};

    return apiJobNoShowCreate(_var, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobNoShowCreate>>,
    TError,
    { _var: string; data: Reason },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Refuse a job for freelancer.
 * @summary Freelancer Refuse Job API
 */
export const apiJobRefuseCreate = (_var: string) => {
  return customInstance<Success>({
    url: `/api/job/${_var}/refuse/`,
    method: 'post',
  });
};

export type ApiJobRefuseCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobRefuseCreate>>
>;

export type ApiJobRefuseCreateMutationError = ErrorType<void>;

export const useApiJobRefuseCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobRefuseCreate>>,
    TError,
    { _var: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobRefuseCreate>>,
    { _var: string }
  > = (props) => {
    const { _var } = props ?? {};

    return apiJobRefuseCreate(_var);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobRefuseCreate>>,
    TError,
    { _var: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Reject a job for freelancer
 * @summary Freelancer Reject Job API
 */
export const apiJobRejectCreate = (_var: string, jobReject: JobReject) => {
  return customInstance<Success>({
    url: `/api/job/${_var}/reject/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: jobReject,
  });
};

export type ApiJobRejectCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobRejectCreate>>
>;
export type ApiJobRejectCreateMutationBody = JobReject;
export type ApiJobRejectCreateMutationError = ErrorType<void>;

export const useApiJobRejectCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobRejectCreate>>,
    TError,
    { _var: string; data: JobReject },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobRejectCreate>>,
    { _var: string; data: JobReject }
  > = (props) => {
    const { _var, data } = props ?? {};

    return apiJobRejectCreate(_var, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobRejectCreate>>,
    TError,
    { _var: string; data: JobReject },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get all available jobs for freelancers
 * @summary Freelancer Available Jobs
 */
export const apiJobsAvailableList = (
  params?: ApiJobsAvailableListParams,
  signal?: AbortSignal,
) => {
  return customInstance<AvailableJobAd[]>({
    url: `/api/jobs/available/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiJobsAvailableListQueryKey = (
  params?: ApiJobsAvailableListParams,
) => [`/api/jobs/available/`, ...(params ? [params] : [])];

export type ApiJobsAvailableListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiJobsAvailableList>>
>;
export type ApiJobsAvailableListQueryError = ErrorType<unknown>;

export const useApiJobsAvailableList = <
  TData = Awaited<ReturnType<typeof apiJobsAvailableList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiJobsAvailableListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiJobsAvailableList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiJobsAvailableListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiJobsAvailableList>>
  > = ({ signal }) => apiJobsAvailableList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiJobsAvailableList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get list of all the accepted(planned) jobs by freelancer.
 * @summary Freelancer Accepted(Planned) Jobs API
 */
export const apiJobsPlannedList = (signal?: AbortSignal) => {
  return customInstance<JobAd[]>({
    url: `/api/jobs/planned/`,
    method: 'get',
    signal,
  });
};

export const getApiJobsPlannedListQueryKey = () => [`/api/jobs/planned/`];

export type ApiJobsPlannedListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiJobsPlannedList>>
>;
export type ApiJobsPlannedListQueryError = ErrorType<unknown>;

export const useApiJobsPlannedList = <
  TData = Awaited<ReturnType<typeof apiJobsPlannedList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiJobsPlannedList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiJobsPlannedListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiJobsPlannedList>>
  > = ({ signal }) => apiJobsPlannedList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiJobsPlannedList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get details of a location of an organisation.
 * @summary Organisation Location Details API
 */
export const apiLocationDetailsRead = (id: string, signal?: AbortSignal) => {
  return customInstance<LocationDetails>({
    url: `/api/location/${id}/details/`,
    method: 'get',
    signal,
  });
};

export const getApiLocationDetailsReadQueryKey = (id: string) => [
  `/api/location/${id}/details/`,
];

export type ApiLocationDetailsReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLocationDetailsRead>>
>;
export type ApiLocationDetailsReadQueryError = ErrorType<unknown>;

export const useApiLocationDetailsRead = <
  TData = Awaited<ReturnType<typeof apiLocationDetailsRead>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiLocationDetailsRead>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiLocationDetailsReadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiLocationDetailsRead>>
  > = ({ signal }) => apiLocationDetailsRead(id, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiLocationDetailsRead>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get Freelance Plaza Migration Config
 * @summary Freelance Plaza Migration Config API
 */
export const apiMigrationList = (signal?: AbortSignal) => {
  return customInstance<Property[]>({
    url: `/api/migration/`,
    method: 'get',
    signal,
  });
};

export const getApiMigrationListQueryKey = () => [`/api/migration/`];

export type ApiMigrationListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMigrationList>>
>;
export type ApiMigrationListQueryError = ErrorType<unknown>;

export const useApiMigrationList = <
  TData = Awaited<ReturnType<typeof apiMigrationList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiMigrationList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMigrationListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiMigrationList>>
  > = ({ signal }) => apiMigrationList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiMigrationList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Retrieve and update user details
 * @summary User Profile API
 */
export const apiMyselfRead = (signal?: AbortSignal) => {
  return customInstance<User>({ url: `/api/myself/`, method: 'get', signal });
};

export const getApiMyselfReadQueryKey = () => [`/api/myself/`];

export type ApiMyselfReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMyselfRead>>
>;
export type ApiMyselfReadQueryError = ErrorType<unknown>;

export const useApiMyselfRead = <
  TData = Awaited<ReturnType<typeof apiMyselfRead>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiMyselfRead>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMyselfReadQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMyselfRead>>> = ({
    signal,
  }) => apiMyselfRead(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiMyselfRead>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Retrieve and update user details
 * @summary User Profile API
 */
export const apiMyselfUpdate = (userBody: UserBody) => {
  return customInstance<User>({
    url: `/api/myself/`,
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    data: userBody,
  });
};

export type ApiMyselfUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMyselfUpdate>>
>;
export type ApiMyselfUpdateMutationBody = UserBody;
export type ApiMyselfUpdateMutationError = ErrorType<unknown>;

export const useApiMyselfUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMyselfUpdate>>,
    TError,
    { data: UserBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMyselfUpdate>>,
    { data: UserBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiMyselfUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMyselfUpdate>>,
    TError,
    { data: UserBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Retrieve and update user details
 * @summary User Profile API
 */
export const apiMyselfPartialUpdate = (userBody: UserBody) => {
  return customInstance<User>({
    url: `/api/myself/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/json' },
    data: userBody,
  });
};

export type ApiMyselfPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMyselfPartialUpdate>>
>;
export type ApiMyselfPartialUpdateMutationBody = UserBody;
export type ApiMyselfPartialUpdateMutationError = ErrorType<unknown>;

export const useApiMyselfPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMyselfPartialUpdate>>,
    TError,
    { data: UserBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMyselfPartialUpdate>>,
    { data: UserBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiMyselfPartialUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMyselfPartialUpdate>>,
    TError,
    { data: UserBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Change the freelancer account password.
 * @summary Freelancer Change Password
 */
export const apiMyselfPasswordUpdate = (
  changePasswordBody: ChangePasswordBody,
) => {
  return customInstance<ChangePassword>({
    url: `/api/myself/password/`,
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    data: changePasswordBody,
  });
};

export type ApiMyselfPasswordUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMyselfPasswordUpdate>>
>;
export type ApiMyselfPasswordUpdateMutationBody = ChangePasswordBody;
export type ApiMyselfPasswordUpdateMutationError = ErrorType<unknown>;

export const useApiMyselfPasswordUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMyselfPasswordUpdate>>,
    TError,
    { data: ChangePasswordBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMyselfPasswordUpdate>>,
    { data: ChangePasswordBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiMyselfPasswordUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMyselfPasswordUpdate>>,
    TError,
    { data: ChangePasswordBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Change the freelancer account password.
 * @summary Freelancer Change Password
 */
export const apiMyselfPasswordPartialUpdate = (
  changePasswordBody: ChangePasswordBody,
) => {
  return customInstance<ChangePassword>({
    url: `/api/myself/password/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/json' },
    data: changePasswordBody,
  });
};

export type ApiMyselfPasswordPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMyselfPasswordPartialUpdate>>
>;
export type ApiMyselfPasswordPartialUpdateMutationBody = ChangePasswordBody;
export type ApiMyselfPasswordPartialUpdateMutationError = ErrorType<unknown>;

export const useApiMyselfPasswordPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMyselfPasswordPartialUpdate>>,
    TError,
    { data: ChangePasswordBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMyselfPasswordPartialUpdate>>,
    { data: ChangePasswordBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiMyselfPasswordPartialUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMyselfPasswordPartialUpdate>>,
    TError,
    { data: ChangePasswordBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get list of Notifications for the freelancer.
 * @summary Freelancer Notifications API
 */
export const apiNotificationsList = (signal?: AbortSignal) => {
  return customInstance<Notification[]>({
    url: `/api/notifications/`,
    method: 'get',
    signal,
  });
};

export const getApiNotificationsListQueryKey = () => [`/api/notifications/`];

export type ApiNotificationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiNotificationsList>>
>;
export type ApiNotificationsListQueryError = ErrorType<unknown>;

export const useApiNotificationsList = <
  TData = Awaited<ReturnType<typeof apiNotificationsList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiNotificationsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiNotificationsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiNotificationsList>>
  > = ({ signal }) => apiNotificationsList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiNotificationsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Add/get/update the Notification preference for a freelancer.
 * @summary Freelancer Notification Preference API
 */
export const apiNotificationsPrefsRead = (signal?: AbortSignal) => {
  return customInstance<NotificationPreferences>({
    url: `/api/notifications/prefs/`,
    method: 'get',
    signal,
  });
};

export const getApiNotificationsPrefsReadQueryKey = () => [
  `/api/notifications/prefs/`,
];

export type ApiNotificationsPrefsReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiNotificationsPrefsRead>>
>;
export type ApiNotificationsPrefsReadQueryError = ErrorType<unknown>;

export const useApiNotificationsPrefsRead = <
  TData = Awaited<ReturnType<typeof apiNotificationsPrefsRead>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiNotificationsPrefsRead>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiNotificationsPrefsReadQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiNotificationsPrefsRead>>
  > = ({ signal }) => apiNotificationsPrefsRead(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiNotificationsPrefsRead>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Add/get/update the Notification preference for a freelancer.
 * @summary Freelancer Notification Preference API
 */
export const apiNotificationsPrefsUpdate = (
  notificationPreferencesBody: NotificationPreferencesBody,
) => {
  return customInstance<NotificationPreferences>({
    url: `/api/notifications/prefs/`,
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    data: notificationPreferencesBody,
  });
};

export type ApiNotificationsPrefsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiNotificationsPrefsUpdate>>
>;
export type ApiNotificationsPrefsUpdateMutationBody =
  NotificationPreferencesBody;
export type ApiNotificationsPrefsUpdateMutationError = ErrorType<unknown>;

export const useApiNotificationsPrefsUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiNotificationsPrefsUpdate>>,
    TError,
    { data: NotificationPreferencesBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiNotificationsPrefsUpdate>>,
    { data: NotificationPreferencesBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiNotificationsPrefsUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiNotificationsPrefsUpdate>>,
    TError,
    { data: NotificationPreferencesBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Add/get/update the Notification preference for a freelancer.
 * @summary Freelancer Notification Preference API
 */
export const apiNotificationsPrefsPartialUpdate = (
  notificationPreferencesBody: NotificationPreferencesBody,
) => {
  return customInstance<NotificationPreferences>({
    url: `/api/notifications/prefs/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/json' },
    data: notificationPreferencesBody,
  });
};

export type ApiNotificationsPrefsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiNotificationsPrefsPartialUpdate>>
>;
export type ApiNotificationsPrefsPartialUpdateMutationBody =
  NotificationPreferencesBody;
export type ApiNotificationsPrefsPartialUpdateMutationError =
  ErrorType<unknown>;

export const useApiNotificationsPrefsPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiNotificationsPrefsPartialUpdate>>,
    TError,
    { data: NotificationPreferencesBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiNotificationsPrefsPartialUpdate>>,
    { data: NotificationPreferencesBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiNotificationsPrefsPartialUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiNotificationsPrefsPartialUpdate>>,
    TError,
    { data: NotificationPreferencesBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get Organisation details for organisations that the user is an admin of.
 * @summary Organisation Admin Details API
 */
export const apiOrganisationAdminList = (signal?: AbortSignal) => {
  return customInstance<OrganisationAdminDetails[]>({
    url: `/api/organisation/admin/`,
    method: 'get',
    signal,
  });
};

export const getApiOrganisationAdminListQueryKey = () => [
  `/api/organisation/admin/`,
];

export type ApiOrganisationAdminListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationAdminList>>
>;
export type ApiOrganisationAdminListQueryError = ErrorType<unknown>;

export const useApiOrganisationAdminList = <
  TData = Awaited<ReturnType<typeof apiOrganisationAdminList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiOrganisationAdminList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiOrganisationAdminListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationAdminList>>
  > = ({ signal }) => apiOrganisationAdminList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationAdminList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get list of blocked freelancers(users) for organisation user's all organisation(s).
 */
export const organisationListBlockedFreelancersUser = (
  params?: OrganisationListBlockedFreelancersUserParams,
  signal?: AbortSignal,
) => {
  return customInstance<OrganisationListBlockedFreelancersUser200>({
    url: `/api/organisation/blocked/`,
    method: 'get',
    params,
    signal,
  });
};

export const getOrganisationListBlockedFreelancersUserQueryKey = (
  params?: OrganisationListBlockedFreelancersUserParams,
) => [`/api/organisation/blocked/`, ...(params ? [params] : [])];

export type OrganisationListBlockedFreelancersUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof organisationListBlockedFreelancersUser>>
>;
export type OrganisationListBlockedFreelancersUserQueryError = ErrorType<void>;

export const useOrganisationListBlockedFreelancersUser = <
  TData = Awaited<ReturnType<typeof organisationListBlockedFreelancersUser>>,
  TError = ErrorType<void>,
>(
  params?: OrganisationListBlockedFreelancersUserParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof organisationListBlockedFreelancersUser>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getOrganisationListBlockedFreelancersUserQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof organisationListBlockedFreelancersUser>>
  > = ({ signal }) => organisationListBlockedFreelancersUser(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof organisationListBlockedFreelancersUser>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Blocks a freelancer(user) for organisation user's all organisation(s).
 */
export const organisationBlockAFreelancerUser = (
  favoritesAndBlockedActionBody: FavoritesAndBlockedActionBody,
) => {
  return customInstance<Success>({
    url: `/api/organisation/blocked/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: favoritesAndBlockedActionBody,
  });
};

export type OrganisationBlockAFreelancerUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof organisationBlockAFreelancerUser>>
>;
export type OrganisationBlockAFreelancerUserMutationBody =
  FavoritesAndBlockedActionBody;
export type OrganisationBlockAFreelancerUserMutationError = ErrorType<void>;

export const useOrganisationBlockAFreelancerUser = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organisationBlockAFreelancerUser>>,
    TError,
    { data: FavoritesAndBlockedActionBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organisationBlockAFreelancerUser>>,
    { data: FavoritesAndBlockedActionBody }
  > = (props) => {
    const { data } = props ?? {};

    return organisationBlockAFreelancerUser(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof organisationBlockAFreelancerUser>>,
    TError,
    { data: FavoritesAndBlockedActionBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Unblocks(remove from blocked) a freelancer(user) for organisation user's all organisation(s).
 */
export const organisationUnblockAFreelancerUser = (userId: string) => {
  return customInstance<Success>({
    url: `/api/organisation/blocked/user/${userId}/`,
    method: 'delete',
  });
};

export type OrganisationUnblockAFreelancerUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof organisationUnblockAFreelancerUser>>
>;

export type OrganisationUnblockAFreelancerUserMutationError = ErrorType<void>;

export const useOrganisationUnblockAFreelancerUser = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organisationUnblockAFreelancerUser>>,
    TError,
    { userId: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organisationUnblockAFreelancerUser>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return organisationUnblockAFreelancerUser(userId);
  };

  return useMutation<
    Awaited<ReturnType<typeof organisationUnblockAFreelancerUser>>,
    TError,
    { userId: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiOrganisationContractsRequestCreateCreate = (
  contractRequest: ContractRequest,
) => {
  return customInstance<ContractRequest>({
    url: `/api/organisation/contracts_request/create`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: contractRequest,
  });
};

export type ApiOrganisationContractsRequestCreateCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiOrganisationContractsRequestCreateCreate>>
  >;
export type ApiOrganisationContractsRequestCreateCreateMutationBody =
  ContractRequest;
export type ApiOrganisationContractsRequestCreateCreateMutationError =
  ErrorType<unknown>;

export const useApiOrganisationContractsRequestCreateCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrganisationContractsRequestCreateCreate>>,
    TError,
    { data: ContractRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrganisationContractsRequestCreateCreate>>,
    { data: ContractRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiOrganisationContractsRequestCreateCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiOrganisationContractsRequestCreateCreate>>,
    TError,
    { data: ContractRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * get contracts requests made by organization
 * @summary Get Contracts requests  API
 */
export const apiOrganisationContractsRequestsList = (signal?: AbortSignal) => {
  return customInstance<ContractRequest[]>({
    url: `/api/organisation/contracts_requests/`,
    method: 'get',
    signal,
  });
};

export const getApiOrganisationContractsRequestsListQueryKey = () => [
  `/api/organisation/contracts_requests/`,
];

export type ApiOrganisationContractsRequestsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationContractsRequestsList>>
>;
export type ApiOrganisationContractsRequestsListQueryError = ErrorType<unknown>;

export const useApiOrganisationContractsRequestsList = <
  TData = Awaited<ReturnType<typeof apiOrganisationContractsRequestsList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiOrganisationContractsRequestsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiOrganisationContractsRequestsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationContractsRequestsList>>
  > = ({ signal }) => apiOrganisationContractsRequestsList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationContractsRequestsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const apiOrganisationDerivedJobsEditCreate = (
  jobId: string,
  editDerivedJob: EditDerivedJob,
) => {
  return customInstance<Success>({
    url: `/api/organisation/derived_jobs/${jobId}/edit/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: editDerivedJob,
  });
};

export type ApiOrganisationDerivedJobsEditCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationDerivedJobsEditCreate>>
>;
export type ApiOrganisationDerivedJobsEditCreateMutationBody = EditDerivedJob;
export type ApiOrganisationDerivedJobsEditCreateMutationError = ErrorType<void>;

export const useApiOrganisationDerivedJobsEditCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrganisationDerivedJobsEditCreate>>,
    TError,
    { jobId: string; data: EditDerivedJob },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrganisationDerivedJobsEditCreate>>,
    { jobId: string; data: EditDerivedJob }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return apiOrganisationDerivedJobsEditCreate(jobId, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiOrganisationDerivedJobsEditCreate>>,
    TError,
    { jobId: string; data: EditDerivedJob },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get list of favorite freelancers(users) for organisation user's all organisation(s).
 */
export const organisationListFavoriteFreelancersUser = (
  params?: OrganisationListFavoriteFreelancersUserParams,
  signal?: AbortSignal,
) => {
  return customInstance<OrganisationListFavoriteFreelancersUser200>({
    url: `/api/organisation/favorites/`,
    method: 'get',
    params,
    signal,
  });
};

export const getOrganisationListFavoriteFreelancersUserQueryKey = (
  params?: OrganisationListFavoriteFreelancersUserParams,
) => [`/api/organisation/favorites/`, ...(params ? [params] : [])];

export type OrganisationListFavoriteFreelancersUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof organisationListFavoriteFreelancersUser>>
>;
export type OrganisationListFavoriteFreelancersUserQueryError = ErrorType<void>;

export const useOrganisationListFavoriteFreelancersUser = <
  TData = Awaited<ReturnType<typeof organisationListFavoriteFreelancersUser>>,
  TError = ErrorType<void>,
>(
  params?: OrganisationListFavoriteFreelancersUserParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof organisationListFavoriteFreelancersUser>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getOrganisationListFavoriteFreelancersUserQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof organisationListFavoriteFreelancersUser>>
  > = ({ signal }) => organisationListFavoriteFreelancersUser(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof organisationListFavoriteFreelancersUser>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Favorite a freelancer(user) for organisation user's all organisation(s).
 */
export const organisationFavoriteAFreelancerUser = (
  favoritesAndBlockedActionBody: FavoritesAndBlockedActionBody,
) => {
  return customInstance<Success>({
    url: `/api/organisation/favorites/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: favoritesAndBlockedActionBody,
  });
};

export type OrganisationFavoriteAFreelancerUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof organisationFavoriteAFreelancerUser>>
>;
export type OrganisationFavoriteAFreelancerUserMutationBody =
  FavoritesAndBlockedActionBody;
export type OrganisationFavoriteAFreelancerUserMutationError = ErrorType<void>;

export const useOrganisationFavoriteAFreelancerUser = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organisationFavoriteAFreelancerUser>>,
    TError,
    { data: FavoritesAndBlockedActionBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organisationFavoriteAFreelancerUser>>,
    { data: FavoritesAndBlockedActionBody }
  > = (props) => {
    const { data } = props ?? {};

    return organisationFavoriteAFreelancerUser(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof organisationFavoriteAFreelancerUser>>,
    TError,
    { data: FavoritesAndBlockedActionBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Unfavorite(remove from favorite) a freelancer(user) for organisation user's all organisation(s).
 */
export const organisationUnfavoriteAFreelancerUser = (userId: string) => {
  return customInstance<Success>({
    url: `/api/organisation/favorites/user/${userId}/`,
    method: 'delete',
  });
};

export type OrganisationUnfavoriteAFreelancerUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof organisationUnfavoriteAFreelancerUser>>
>;

export type OrganisationUnfavoriteAFreelancerUserMutationError =
  ErrorType<void>;

export const useOrganisationUnfavoriteAFreelancerUser = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organisationUnfavoriteAFreelancerUser>>,
    TError,
    { userId: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organisationUnfavoriteAFreelancerUser>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return organisationUnfavoriteAFreelancerUser(userId);
  };

  return useMutation<
    Awaited<ReturnType<typeof organisationUnfavoriteAFreelancerUser>>,
    TError,
    { userId: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get all available days for freelancers
 * @summary Freelancer Available Jobs
 */
export const apiOrganisationFreelancerAvailabilityRead = (
  freelancerId: string,
  params?: ApiOrganisationFreelancerAvailabilityReadParams,
  signal?: AbortSignal,
) => {
  return customInstance<FreelancerAvailability[]>({
    url: `/api/organisation/freelancer_availability/${freelancerId}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiOrganisationFreelancerAvailabilityReadQueryKey = (
  freelancerId: string,
  params?: ApiOrganisationFreelancerAvailabilityReadParams,
) => [
  `/api/organisation/freelancer_availability/${freelancerId}/`,
  ...(params ? [params] : []),
];

export type ApiOrganisationFreelancerAvailabilityReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationFreelancerAvailabilityRead>>
>;
export type ApiOrganisationFreelancerAvailabilityReadQueryError =
  ErrorType<unknown>;

export const useApiOrganisationFreelancerAvailabilityRead = <
  TData = Awaited<ReturnType<typeof apiOrganisationFreelancerAvailabilityRead>>,
  TError = ErrorType<unknown>,
>(
  freelancerId: string,
  params?: ApiOrganisationFreelancerAvailabilityReadParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationFreelancerAvailabilityRead>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiOrganisationFreelancerAvailabilityReadQueryKey(freelancerId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationFreelancerAvailabilityRead>>
  > = ({ signal }) =>
    apiOrganisationFreelancerAvailabilityRead(freelancerId, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationFreelancerAvailabilityRead>>,
    TError,
    TData
  >(queryKey, queryFn, {
    enabled: !!freelancerId,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Freelancer Details API - for Organisation
 */
export const apiOrganisationFreelancersDetailsList = (
  freelancerId: string,
  jobId: string,
  params?: ApiOrganisationFreelancersDetailsListParams,
  signal?: AbortSignal,
) => {
  return customInstance<FreelancerDetail>({
    url: `/api/organisation/freelancers/${freelancerId}/${jobId}/details/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiOrganisationFreelancersDetailsListQueryKey = (
  freelancerId: string,
  jobId: string,
  params?: ApiOrganisationFreelancersDetailsListParams,
) => [
  `/api/organisation/freelancers/${freelancerId}/${jobId}/details/`,
  ...(params ? [params] : []),
];

export type ApiOrganisationFreelancersDetailsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationFreelancersDetailsList>>
>;
export type ApiOrganisationFreelancersDetailsListQueryError = ErrorType<void>;

export const useApiOrganisationFreelancersDetailsList = <
  TData = Awaited<ReturnType<typeof apiOrganisationFreelancersDetailsList>>,
  TError = ErrorType<void>,
>(
  freelancerId: string,
  jobId: string,
  params?: ApiOrganisationFreelancersDetailsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationFreelancersDetailsList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiOrganisationFreelancersDetailsListQueryKey(
      freelancerId,
      jobId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationFreelancersDetailsList>>
  > = ({ signal }) =>
    apiOrganisationFreelancersDetailsList(freelancerId, jobId, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationFreelancersDetailsList>>,
    TError,
    TData
  >(queryKey, queryFn, {
    enabled: !!(freelancerId && jobId),
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get list of all the Jobs of Organisation(s).
 * @summary Organisation Jobs API
 */
export const apiOrganisationJobsList = (
  params: ApiOrganisationJobsListParams,
  signal?: AbortSignal,
) => {
  return customInstance<ApiOrganisationJobsList200>({
    url: `/api/organisation/jobs/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiOrganisationJobsListQueryKey = (
  params: ApiOrganisationJobsListParams,
) => [`/api/organisation/jobs/`, ...(params ? [params] : [])];

export type ApiOrganisationJobsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationJobsList>>
>;
export type ApiOrganisationJobsListQueryError = ErrorType<unknown>;

export const useApiOrganisationJobsList = <
  TData = Awaited<ReturnType<typeof apiOrganisationJobsList>>,
  TError = ErrorType<unknown>,
>(
  params: ApiOrganisationJobsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationJobsList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiOrganisationJobsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationJobsList>>
  > = ({ signal }) => apiOrganisationJobsList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationJobsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Export list of Jobs of Organisation(s).
 * @summary Organisation Jobs Export API
 */
export const apiOrganisationJobsExportList = (
  params: ApiOrganisationJobsExportListParams,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/api/organisation/jobs/export/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiOrganisationJobsExportListQueryKey = (
  params: ApiOrganisationJobsExportListParams,
) => [`/api/organisation/jobs/export/`, ...(params ? [params] : [])];

export type ApiOrganisationJobsExportListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationJobsExportList>>
>;
export type ApiOrganisationJobsExportListQueryError = ErrorType<unknown>;

export const useApiOrganisationJobsExportList = <
  TData = Awaited<ReturnType<typeof apiOrganisationJobsExportList>>,
  TError = ErrorType<unknown>,
>(
  params: ApiOrganisationJobsExportListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationJobsExportList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiOrganisationJobsExportListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationJobsExportList>>
  > = ({ signal }) => apiOrganisationJobsExportList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationJobsExportList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get job details of one's organisation job.
 * @summary Organisation Job Details API
 */
export const apiOrganisationJobsDetailsRead = (
  id: number,
  signal?: AbortSignal,
) => {
  return customInstance<OrganisationJobDetails>({
    url: `/api/organisation/jobs/${id}/details/`,
    method: 'get',
    signal,
  });
};

export const getApiOrganisationJobsDetailsReadQueryKey = (id: number) => [
  `/api/organisation/jobs/${id}/details/`,
];

export type ApiOrganisationJobsDetailsReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationJobsDetailsRead>>
>;
export type ApiOrganisationJobsDetailsReadQueryError = ErrorType<unknown>;

export const useApiOrganisationJobsDetailsRead = <
  TData = Awaited<ReturnType<typeof apiOrganisationJobsDetailsRead>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationJobsDetailsRead>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiOrganisationJobsDetailsReadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationJobsDetailsRead>>
  > = ({ signal }) => apiOrganisationJobsDetailsRead(id, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationJobsDetailsRead>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Invite all freelancers for a particular job of an organisation.
 * @summary Organisation Job Invite All API
 */
export const apiOrganisationJobsInviteAllCreate = (id: string) => {
  return customInstance<Success>({
    url: `/api/organisation/jobs/${id}/invite-all/`,
    method: 'post',
  });
};

export type ApiOrganisationJobsInviteAllCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationJobsInviteAllCreate>>
>;

export type ApiOrganisationJobsInviteAllCreateMutationError = ErrorType<void>;

export const useApiOrganisationJobsInviteAllCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrganisationJobsInviteAllCreate>>,
    TError,
    { id: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrganisationJobsInviteAllCreate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return apiOrganisationJobsInviteAllCreate(id);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiOrganisationJobsInviteAllCreate>>,
    TError,
    { id: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiOrganisationJobsToUrgentCreate = (jobId: string) => {
  return customInstance<Success>({
    url: `/api/organisation/jobs/${jobId}/to_urgent/`,
    method: 'post',
  });
};

export type ApiOrganisationJobsToUrgentCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationJobsToUrgentCreate>>
>;

export type ApiOrganisationJobsToUrgentCreateMutationError = ErrorType<void>;

export const useApiOrganisationJobsToUrgentCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrganisationJobsToUrgentCreate>>,
    TError,
    { jobId: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrganisationJobsToUrgentCreate>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return apiOrganisationJobsToUrgentCreate(jobId);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiOrganisationJobsToUrgentCreate>>,
    TError,
    { jobId: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * returns derived personal jobads from a given period job.
 * @summary Organisation derived jobs
 */
export const apiOrganisationPeriodJobDerivedJobadsList = (
  jobId: string,
  signal?: AbortSignal,
) => {
  return customInstance<DerivedJobAd[]>({
    url: `/api/organisation/period_job/${jobId}/derived_jobads/`,
    method: 'get',
    signal,
  });
};

export const getApiOrganisationPeriodJobDerivedJobadsListQueryKey = (
  jobId: string,
) => [`/api/organisation/period_job/${jobId}/derived_jobads/`];

export type ApiOrganisationPeriodJobDerivedJobadsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationPeriodJobDerivedJobadsList>>
>;
export type ApiOrganisationPeriodJobDerivedJobadsListQueryError =
  ErrorType<unknown>;

export const useApiOrganisationPeriodJobDerivedJobadsList = <
  TData = Awaited<ReturnType<typeof apiOrganisationPeriodJobDerivedJobadsList>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationPeriodJobDerivedJobadsList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiOrganisationPeriodJobDerivedJobadsListQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobDerivedJobadsList>>
  > = ({ signal }) => apiOrganisationPeriodJobDerivedJobadsList(jobId, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobDerivedJobadsList>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!jobId, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * returns all period jobs for an organization (hidden jobs are not visible)
 * @summary Organisation period jobs list
 */
export const apiOrganisationPeriodJobsList = (signal?: AbortSignal) => {
  return customInstance<OrganisationPeriodJob[]>({
    url: `/api/organisation/period_jobs/`,
    method: 'get',
    signal,
  });
};

export const getApiOrganisationPeriodJobsListQueryKey = () => [
  `/api/organisation/period_jobs/`,
];

export type ApiOrganisationPeriodJobsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationPeriodJobsList>>
>;
export type ApiOrganisationPeriodJobsListQueryError = ErrorType<unknown>;

export const useApiOrganisationPeriodJobsList = <
  TData = Awaited<ReturnType<typeof apiOrganisationPeriodJobsList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiOrganisationPeriodJobsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsList>>
  > = ({ signal }) => apiOrganisationPeriodJobsList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get period job details of one's organisation job.
 * @summary Organisation Period Job Details API
 */
export const apiOrganisationPeriodJobsDetailsRead = (
  id: number,
  signal?: AbortSignal,
) => {
  return customInstance<OrganisationPeriodJobDetails>({
    url: `/api/organisation/period_jobs/${id}/details/`,
    method: 'get',
    signal,
  });
};

export const getApiOrganisationPeriodJobsDetailsReadQueryKey = (id: number) => [
  `/api/organisation/period_jobs/${id}/details/`,
];

export type ApiOrganisationPeriodJobsDetailsReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationPeriodJobsDetailsRead>>
>;
export type ApiOrganisationPeriodJobsDetailsReadQueryError = ErrorType<unknown>;

export const useApiOrganisationPeriodJobsDetailsRead = <
  TData = Awaited<ReturnType<typeof apiOrganisationPeriodJobsDetailsRead>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationPeriodJobsDetailsRead>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiOrganisationPeriodJobsDetailsReadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsDetailsRead>>
  > = ({ signal }) => apiOrganisationPeriodJobsDetailsRead(id, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsDetailsRead>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiOrganisationPeriodJobsAssignmentDetailsList = (
  jobId: string,
  signal?: AbortSignal,
) => {
  return customInstance<PeriodJobAssignmentDetails>({
    url: `/api/organisation/period_jobs/${jobId}/assignment_details/`,
    method: 'get',
    signal,
  });
};

export const getApiOrganisationPeriodJobsAssignmentDetailsListQueryKey = (
  jobId: string,
) => [`/api/organisation/period_jobs/${jobId}/assignment_details/`];

export type ApiOrganisationPeriodJobsAssignmentDetailsListQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsAssignmentDetailsList>>
  >;
export type ApiOrganisationPeriodJobsAssignmentDetailsListQueryError =
  ErrorType<void>;

export const useApiOrganisationPeriodJobsAssignmentDetailsList = <
  TData = Awaited<
    ReturnType<typeof apiOrganisationPeriodJobsAssignmentDetailsList>
  >,
  TError = ErrorType<void>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof apiOrganisationPeriodJobsAssignmentDetailsList>
      >,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiOrganisationPeriodJobsAssignmentDetailsListQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsAssignmentDetailsList>>
  > = ({ signal }) =>
    apiOrganisationPeriodJobsAssignmentDetailsList(jobId, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsAssignmentDetailsList>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!jobId, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * set period job statuis to closed
 * @summary Organisation Close Period job endpoint
 */
export const apiOrganisationPeriodJobsCloseCreate = (jobId: string) => {
  return customInstance<void>({
    url: `/api/organisation/period_jobs/${jobId}/close/`,
    method: 'post',
  });
};

export type ApiOrganisationPeriodJobsCloseCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationPeriodJobsCloseCreate>>
>;

export type ApiOrganisationPeriodJobsCloseCreateMutationError =
  ErrorType<unknown>;

export const useApiOrganisationPeriodJobsCloseCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsCloseCreate>>,
    TError,
    { jobId: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsCloseCreate>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return apiOrganisationPeriodJobsCloseCreate(jobId);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsCloseCreate>>,
    TError,
    { jobId: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * set period job status to hidden
 * @summary Organisation Hide Period job endpoint
 */
export const apiOrganisationPeriodJobsHideCreate = (jobId: string) => {
  return customInstance<void>({
    url: `/api/organisation/period_jobs/${jobId}/hide/`,
    method: 'post',
  });
};

export type ApiOrganisationPeriodJobsHideCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationPeriodJobsHideCreate>>
>;

export type ApiOrganisationPeriodJobsHideCreateMutationError =
  ErrorType<unknown>;

export const useApiOrganisationPeriodJobsHideCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsHideCreate>>,
    TError,
    { jobId: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsHideCreate>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return apiOrganisationPeriodJobsHideCreate(jobId);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsHideCreate>>,
    TError,
    { jobId: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * the period job id and the freelancer id are required
 * @summary Endpoint for organisation to confirm a period job with a freelancer
 */
export const apiOrganisationPeriodJobsConfirmCreate = (
  jobId: string,
  freelancerId: string,
) => {
  return customInstance<void>({
    url: `/api/organisation/period_jobs/${jobId}/${freelancerId}/confirm/`,
    method: 'post',
  });
};

export type ApiOrganisationPeriodJobsConfirmCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationPeriodJobsConfirmCreate>>
>;

export type ApiOrganisationPeriodJobsConfirmCreateMutationError =
  ErrorType<unknown>;

export const useApiOrganisationPeriodJobsConfirmCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsConfirmCreate>>,
    TError,
    { jobId: string; freelancerId: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsConfirmCreate>>,
    { jobId: string; freelancerId: string }
  > = (props) => {
    const { jobId, freelancerId } = props ?? {};

    return apiOrganisationPeriodJobsConfirmCreate(jobId, freelancerId);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiOrganisationPeriodJobsConfirmCreate>>,
    TError,
    { jobId: string; freelancerId: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * User details API - for Organisation
 */
export const apiOrganisationUsersDetailsList = (
  userId: string,
  jobId: string,
  params?: ApiOrganisationUsersDetailsListParams,
  signal?: AbortSignal,
) => {
  return customInstance<FreelancerDetail>({
    url: `/api/organisation/users/${userId}/${jobId}/details/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiOrganisationUsersDetailsListQueryKey = (
  userId: string,
  jobId: string,
  params?: ApiOrganisationUsersDetailsListParams,
) => [
  `/api/organisation/users/${userId}/${jobId}/details/`,
  ...(params ? [params] : []),
];

export type ApiOrganisationUsersDetailsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationUsersDetailsList>>
>;
export type ApiOrganisationUsersDetailsListQueryError = ErrorType<void>;

export const useApiOrganisationUsersDetailsList = <
  TData = Awaited<ReturnType<typeof apiOrganisationUsersDetailsList>>,
  TError = ErrorType<void>,
>(
  userId: string,
  jobId: string,
  params?: ApiOrganisationUsersDetailsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationUsersDetailsList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiOrganisationUsersDetailsListQueryKey(userId, jobId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationUsersDetailsList>>
  > = ({ signal }) =>
    apiOrganisationUsersDetailsList(userId, jobId, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationUsersDetailsList>>,
    TError,
    TData
  >(queryKey, queryFn, {
    enabled: !!(userId && jobId),
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get organisation details.
 * @summary Organisation Details API
 */
export const apiOrganisationDetailsRead = (
  id: string,
  signal?: AbortSignal,
) => {
  return customInstance<OrganisationDetails>({
    url: `/api/organisation/${id}/details/`,
    method: 'get',
    signal,
  });
};

export const getApiOrganisationDetailsReadQueryKey = (id: string) => [
  `/api/organisation/${id}/details/`,
];

export type ApiOrganisationDetailsReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationDetailsRead>>
>;
export type ApiOrganisationDetailsReadQueryError = ErrorType<unknown>;

export const useApiOrganisationDetailsRead = <
  TData = Awaited<ReturnType<typeof apiOrganisationDetailsRead>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationDetailsRead>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiOrganisationDetailsReadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationDetailsRead>>
  > = ({ signal }) => apiOrganisationDetailsRead(id, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationDetailsRead>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get organisation's list of locations and rate rules.
 * @summary Organisation's Location and Rate Rules List API
 */
export const apiOrganisationLocationsRateRulesRead = (
  id: string,
  signal?: AbortSignal,
) => {
  return customInstance<OrganisationLocationRateRule>({
    url: `/api/organisation/${id}/locations-rate-rules/`,
    method: 'get',
    signal,
  });
};

export const getApiOrganisationLocationsRateRulesReadQueryKey = (
  id: string,
) => [`/api/organisation/${id}/locations-rate-rules/`];

export type ApiOrganisationLocationsRateRulesReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationLocationsRateRulesRead>>
>;
export type ApiOrganisationLocationsRateRulesReadQueryError = ErrorType<void>;

export const useApiOrganisationLocationsRateRulesRead = <
  TData = Awaited<ReturnType<typeof apiOrganisationLocationsRateRulesRead>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationLocationsRateRulesRead>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiOrganisationLocationsRateRulesReadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationLocationsRateRulesRead>>
  > = ({ signal }) => apiOrganisationLocationsRateRulesRead(id, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationLocationsRateRulesRead>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get Organisation SDB API Key.
 */
export const organisationGetSDBCredentials = (
  id: string,
  signal?: AbortSignal,
) => {
  return customInstance<OrganisationAddSDBCredentials>({
    url: `/api/organisation/${id}/sdb/credentials/`,
    method: 'get',
    signal,
  });
};

export const getOrganisationGetSDBCredentialsQueryKey = (id: string) => [
  `/api/organisation/${id}/sdb/credentials/`,
];

export type OrganisationGetSDBCredentialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof organisationGetSDBCredentials>>
>;
export type OrganisationGetSDBCredentialsQueryError = ErrorType<void>;

export const useOrganisationGetSDBCredentials = <
  TData = Awaited<ReturnType<typeof organisationGetSDBCredentials>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof organisationGetSDBCredentials>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOrganisationGetSDBCredentialsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof organisationGetSDBCredentials>>
  > = ({ signal }) => organisationGetSDBCredentials(id, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof organisationGetSDBCredentials>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Lets Organisation admins add the SDB API Key and Account Name.
 */
export const organisationUpdateSDBCredentials = (
  id: string,
  organisationAddSDBCredentials: OrganisationAddSDBCredentials,
) => {
  return customInstance<OrganisationAddSDBCredentials>({
    url: `/api/organisation/${id}/sdb/credentials/`,
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    data: organisationAddSDBCredentials,
  });
};

export type OrganisationUpdateSDBCredentialsMutationResult = NonNullable<
  Awaited<ReturnType<typeof organisationUpdateSDBCredentials>>
>;
export type OrganisationUpdateSDBCredentialsMutationBody =
  OrganisationAddSDBCredentials;
export type OrganisationUpdateSDBCredentialsMutationError = ErrorType<void>;

export const useOrganisationUpdateSDBCredentials = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organisationUpdateSDBCredentials>>,
    TError,
    { id: string; data: OrganisationAddSDBCredentials },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organisationUpdateSDBCredentials>>,
    { id: string; data: OrganisationAddSDBCredentials }
  > = (props) => {
    const { id, data } = props ?? {};

    return organisationUpdateSDBCredentials(id, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof organisationUpdateSDBCredentials>>,
    TError,
    { id: string; data: OrganisationAddSDBCredentials },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get organisation locations list for locations that the user is admin of
 * @summary Organisation Locations List
 */
export const apiOrganisationLocationsList = (
  organisationId: string,
  signal?: AbortSignal,
) => {
  return customInstance<LocationDetails>({
    url: `/api/organisation/${organisationId}/locations/`,
    method: 'get',
    signal,
  });
};

export const getApiOrganisationLocationsListQueryKey = (
  organisationId: string,
) => [`/api/organisation/${organisationId}/locations/`];

export type ApiOrganisationLocationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationLocationsList>>
>;
export type ApiOrganisationLocationsListQueryError = ErrorType<void>;

export const useApiOrganisationLocationsList = <
  TData = Awaited<ReturnType<typeof apiOrganisationLocationsList>>,
  TError = ErrorType<void>,
>(
  organisationId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationLocationsList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiOrganisationLocationsListQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationLocationsList>>
  > = ({ signal }) => apiOrganisationLocationsList(organisationId, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationLocationsList>>,
    TError,
    TData
  >(queryKey, queryFn, {
    enabled: !!organisationId,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get Rate rules mapping for an organisation.
 * @summary Organisation Rate Rules List API
 */
export const apiOrganisationRaterulesList = (
  organisationId: string,
  signal?: AbortSignal,
) => {
  return customInstance<RateRule[]>({
    url: `/api/organisation/${organisationId}/raterules/`,
    method: 'get',
    signal,
  });
};

export const getApiOrganisationRaterulesListQueryKey = (
  organisationId: string,
) => [`/api/organisation/${organisationId}/raterules/`];

export type ApiOrganisationRaterulesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationRaterulesList>>
>;
export type ApiOrganisationRaterulesListQueryError = ErrorType<void>;

export const useApiOrganisationRaterulesList = <
  TData = Awaited<ReturnType<typeof apiOrganisationRaterulesList>>,
  TError = ErrorType<void>,
>(
  organisationId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationRaterulesList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiOrganisationRaterulesListQueryKey(organisationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationRaterulesList>>
  > = ({ signal }) => apiOrganisationRaterulesList(organisationId, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationRaterulesList>>,
    TError,
    TData
  >(queryKey, queryFn, {
    enabled: !!organisationId,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Fetch SDB jobs for an organisation.
 * @summary Organisation Fetch SDB Jobs API
 */
export const apiOrganisationSdbList = (
  organisationId: string,
  params: ApiOrganisationSdbListParams,
  signal?: AbortSignal,
) => {
  return customInstance<SDBJobs[]>({
    url: `/api/organisation/${organisationId}/sdb/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiOrganisationSdbListQueryKey = (
  organisationId: string,
  params: ApiOrganisationSdbListParams,
) => [`/api/organisation/${organisationId}/sdb/`, ...(params ? [params] : [])];

export type ApiOrganisationSdbListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationSdbList>>
>;
export type ApiOrganisationSdbListQueryError = ErrorType<void>;

export const useApiOrganisationSdbList = <
  TData = Awaited<ReturnType<typeof apiOrganisationSdbList>>,
  TError = ErrorType<void>,
>(
  organisationId: string,
  params: ApiOrganisationSdbListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiOrganisationSdbList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiOrganisationSdbListQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiOrganisationSdbList>>
  > = ({ signal }) => apiOrganisationSdbList(organisationId, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiOrganisationSdbList>>,
    TError,
    TData
  >(queryKey, queryFn, {
    enabled: !!organisationId,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Lets an organisation create SDB jobs. By default, it invites all the freelancers(sorted & available).
 * @summary Organisation Create SDB Jobs
 */
export const apiOrganisationSdbCreateCreate = (
  organisationId: string,
  sDBJobsCreate: SDBJobsCreate,
) => {
  return customInstance<SDBJobsCreate>({
    url: `/api/organisation/${organisationId}/sdb/create/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: sDBJobsCreate,
  });
};

export type ApiOrganisationSdbCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrganisationSdbCreateCreate>>
>;
export type ApiOrganisationSdbCreateCreateMutationBody = SDBJobsCreate;
export type ApiOrganisationSdbCreateCreateMutationError = ErrorType<void>;

export const useApiOrganisationSdbCreateCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrganisationSdbCreateCreate>>,
    TError,
    { organisationId: string; data: SDBJobsCreate },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrganisationSdbCreateCreate>>,
    { organisationId: string; data: SDBJobsCreate }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return apiOrganisationSdbCreateCreate(organisationId, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiOrganisationSdbCreateCreate>>,
    TError,
    { organisationId: string; data: SDBJobsCreate },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Lets a freelancer mark one's self as interested in a period job
 * @summary Freelancer Period Jobs Interested API
 */
export const apiPeriodJobInterestedCreate = (_var: string) => {
  return customInstance<Success>({
    url: `/api/period_job/${_var}/interested/`,
    method: 'post',
  });
};

export type ApiPeriodJobInterestedCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPeriodJobInterestedCreate>>
>;

export type ApiPeriodJobInterestedCreateMutationError = ErrorType<void>;

export const useApiPeriodJobInterestedCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPeriodJobInterestedCreate>>,
    TError,
    { _var: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPeriodJobInterestedCreate>>,
    { _var: string }
  > = (props) => {
    const { _var } = props ?? {};

    return apiPeriodJobInterestedCreate(_var);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPeriodJobInterestedCreate>>,
    TError,
    { _var: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Lets a freelancer mark oneself as NOT interested in a job ad.
 * @summary Period Jobs Refuse API
 */
export const apiPeriodJobRefuseCreate = (_var: string) => {
  return customInstance<Success>({
    url: `/api/period_job/${_var}/refuse/`,
    method: 'post',
  });
};

export type ApiPeriodJobRefuseCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPeriodJobRefuseCreate>>
>;

export type ApiPeriodJobRefuseCreateMutationError = ErrorType<void>;

export const useApiPeriodJobRefuseCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPeriodJobRefuseCreate>>,
    TError,
    { _var: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPeriodJobRefuseCreate>>,
    { _var: string }
  > = (props) => {
    const { _var } = props ?? {};

    return apiPeriodJobRefuseCreate(_var);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPeriodJobRefuseCreate>>,
    TError,
    { _var: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get list of period jobs for freelancer.
 * @summary Freelancer Period Jobs API
 */
export const apiPeriodJobsList = (
  params?: ApiPeriodJobsListParams,
  signal?: AbortSignal,
) => {
  return customInstance<PeriodJob[]>({
    url: `/api/period_jobs/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPeriodJobsListQueryKey = (
  params?: ApiPeriodJobsListParams,
) => [`/api/period_jobs/`, ...(params ? [params] : [])];

export type ApiPeriodJobsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPeriodJobsList>>
>;
export type ApiPeriodJobsListQueryError = ErrorType<void>;

export const useApiPeriodJobsList = <
  TData = Awaited<ReturnType<typeof apiPeriodJobsList>>,
  TError = ErrorType<void>,
>(
  params?: ApiPeriodJobsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPeriodJobsList>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPeriodJobsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPeriodJobsList>>
  > = ({ signal }) => apiPeriodJobsList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPeriodJobsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Create a rating for a job and notify freelancer and organisation
 * @summary Rating API
 */
export const apiRatingCreate = (rating: Rating) => {
  return customInstance<Success>({
    url: `/api/rating/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: rating,
  });
};

export type ApiRatingCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRatingCreate>>
>;
export type ApiRatingCreateMutationBody = Rating;
export type ApiRatingCreateMutationError = ErrorType<void>;

export const useApiRatingCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRatingCreate>>,
    TError,
    { data: Rating },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRatingCreate>>,
    { data: Rating }
  > = (props) => {
    const { data } = props ?? {};

    return apiRatingCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRatingCreate>>,
    TError,
    { data: Rating },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get rating of a job.
 * @summary Organisation Rating Retrieve API
 */
export const apiRatingRead = (jobId: string, signal?: AbortSignal) => {
  return customInstance<RatingDetails>({
    url: `/api/rating/${jobId}/`,
    method: 'get',
    signal,
  });
};

export const getApiRatingReadQueryKey = (jobId: string) => [
  `/api/rating/${jobId}/`,
];

export type ApiRatingReadQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRatingRead>>
>;
export type ApiRatingReadQueryError = ErrorType<void>;

export const useApiRatingRead = <
  TData = Awaited<ReturnType<typeof apiRatingRead>>,
  TError = ErrorType<void>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiRatingRead>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiRatingReadQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRatingRead>>> = ({
    signal,
  }) => apiRatingRead(jobId, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiRatingRead>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!jobId, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRecaptchaValidateCreate = () => {
  return customInstance<void>({
    url: `/api/recaptcha/validate/`,
    method: 'post',
  });
};

export type ApiRecaptchaValidateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRecaptchaValidateCreate>>
>;

export type ApiRecaptchaValidateCreateMutationError = ErrorType<unknown>;

export const useApiRecaptchaValidateCreate = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRecaptchaValidateCreate>>,
    TError,
    TVariables,
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRecaptchaValidateCreate>>,
    TVariables
  > = () => {
    return apiRecaptchaValidateCreate();
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRecaptchaValidateCreate>>,
    TError,
    TVariables,
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Accepts the following POST parameters: email
Returns the success/fail message.
 * @summary Calls Django Auth PasswordResetForm save method.
 */
export const apiResetPasswordCreate = (passwordReset: PasswordReset) => {
  return customInstance<PasswordReset>({
    url: `/api/reset_password/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: passwordReset,
  });
};

export type ApiResetPasswordCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiResetPasswordCreate>>
>;
export type ApiResetPasswordCreateMutationBody = PasswordReset;
export type ApiResetPasswordCreateMutationError = ErrorType<unknown>;

export const useApiResetPasswordCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiResetPasswordCreate>>,
    TError,
    { data: PasswordReset },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiResetPasswordCreate>>,
    { data: PasswordReset }
  > = (props) => {
    const { data } = props ?? {};

    return apiResetPasswordCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiResetPasswordCreate>>,
    TError,
    { data: PasswordReset },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Accepts the following POST parameters: token, uid,
    new_password1, new_password2
Returns the success/fail message.
 * @summary Password reset e-mail link is confirmed, therefore
this resets the user's password.
 */
export const apiResetPasswordConfirmCreate = (
  passwordResetConfirm: PasswordResetConfirm,
) => {
  return customInstance<PasswordResetConfirm>({
    url: `/api/reset_password_confirm/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: passwordResetConfirm,
  });
};

export type ApiResetPasswordConfirmCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiResetPasswordConfirmCreate>>
>;
export type ApiResetPasswordConfirmCreateMutationBody = PasswordResetConfirm;
export type ApiResetPasswordConfirmCreateMutationError = ErrorType<unknown>;

export const useApiResetPasswordConfirmCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiResetPasswordConfirmCreate>>,
    TError,
    { data: PasswordResetConfirm },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiResetPasswordConfirmCreate>>,
    { data: PasswordResetConfirm }
  > = (props) => {
    const { data } = props ?? {};

    return apiResetPasswordConfirmCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiResetPasswordConfirmCreate>>,
    TError,
    { data: PasswordResetConfirm },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Signup a freelancer.
 * @summary Freelancer Signup
 */
export const apiSignupCreate = (signup: Signup) => {
  return customInstance<Success>({
    url: `/api/signup/`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: signup,
  });
};

export type ApiSignupCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSignupCreate>>
>;
export type ApiSignupCreateMutationBody = Signup;
export type ApiSignupCreateMutationError = ErrorType<void>;

export const useApiSignupCreate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSignupCreate>>,
    TError,
    { data: Signup },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSignupCreate>>,
    { data: Signup }
  > = (props) => {
    const { data } = props ?? {};

    return apiSignupCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiSignupCreate>>,
    TError,
    { data: Signup },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Retrieve the status of the 4 steps in the signup flow
 * @summary Freelancer Sign-up Status
 */
export const apiSignupStatusList = (signal?: AbortSignal) => {
  return customInstance<SignUpStatus>({
    url: `/api/signup/status/`,
    method: 'get',
    signal,
  });
};

export const getApiSignupStatusListQueryKey = () => [`/api/signup/status/`];

export type ApiSignupStatusListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSignupStatusList>>
>;
export type ApiSignupStatusListQueryError = ErrorType<unknown>;

export const useApiSignupStatusList = <
  TData = Awaited<ReturnType<typeof apiSignupStatusList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiSignupStatusList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSignupStatusListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSignupStatusList>>
  > = ({ signal }) => apiSignupStatusList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiSignupStatusList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get general statistics regarding freelancers, organisations and jobs.
 * @summary General Stats API
 */
export const apiStatsList = (signal?: AbortSignal) => {
  return customInstance<GeneralStats>({
    url: `/api/stats/`,
    method: 'get',
    signal,
  });
};

export const getApiStatsListQueryKey = () => [`/api/stats/`];

export type ApiStatsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiStatsList>>
>;
export type ApiStatsListQueryError = ErrorType<unknown>;

export const useApiStatsList = <
  TData = Awaited<ReturnType<typeof apiStatsList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiStatsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiStatsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiStatsList>>> = ({
    signal,
  }) => apiStatsList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiStatsList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const apiTokenCreate = () => {
  return customInstance<void>({ url: `/api/token/`, method: 'post' });
};

export type ApiTokenCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTokenCreate>>
>;

export type ApiTokenCreateMutationError = ErrorType<unknown>;

export const useApiTokenCreate = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTokenCreate>>,
    TError,
    TVariables,
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTokenCreate>>,
    TVariables
  > = () => {
    return apiTokenCreate();
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTokenCreate>>,
    TError,
    TVariables,
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get freelancer information based on verified status.

**Note**: Based on verified status, there are two different responses.
Please refer to examples section to get more insight when freelancer is verified and when not.
 * @summary Freelancer Welcome API
 */
export const apiWelcomeList = (signal?: AbortSignal) => {
  return customInstance<WelcomeAPIResponse>({
    url: `/api/welcome/`,
    method: 'get',
    signal,
  });
};

export const getApiWelcomeListQueryKey = () => [`/api/welcome/`];

export type ApiWelcomeListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiWelcomeList>>
>;
export type ApiWelcomeListQueryError = ErrorType<unknown>;

export const useApiWelcomeList = <
  TData = Awaited<ReturnType<typeof apiWelcomeList>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiWelcomeList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiWelcomeListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiWelcomeList>>> = ({
    signal,
  }) => apiWelcomeList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiWelcomeList>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const cmsAdminApiV2betaListingView = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/cms/admin/api/v2beta/pages/`,
    method: 'get',
    signal,
  });
};

export const getCmsAdminApiV2betaListingViewQueryKey = () => [
  `/cms/admin/api/v2beta/pages/`,
];

export type CmsAdminApiV2betaListingViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof cmsAdminApiV2betaListingView>>
>;
export type CmsAdminApiV2betaListingViewQueryError = ErrorType<unknown>;

export const useCmsAdminApiV2betaListingView = <
  TData = Awaited<ReturnType<typeof cmsAdminApiV2betaListingView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cmsAdminApiV2betaListingView>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCmsAdminApiV2betaListingViewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof cmsAdminApiV2betaListingView>>
  > = ({ signal }) => cmsAdminApiV2betaListingView(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof cmsAdminApiV2betaListingView>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const cmsAdminApiV2betaDocumentsFindView = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/cms/admin/api/v2beta/documents/find/`,
    method: 'get',
    signal,
  });
};

export const getCmsAdminApiV2betaDocumentsFindViewQueryKey = () => [
  `/cms/admin/api/v2beta/documents/find/`,
];

export type CmsAdminApiV2betaDocumentsFindViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof cmsAdminApiV2betaDocumentsFindView>>
>;
export type CmsAdminApiV2betaDocumentsFindViewQueryError = ErrorType<unknown>;

export const useCmsAdminApiV2betaDocumentsFindView = <
  TData = Awaited<ReturnType<typeof cmsAdminApiV2betaDocumentsFindView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cmsAdminApiV2betaDocumentsFindView>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCmsAdminApiV2betaDocumentsFindViewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof cmsAdminApiV2betaDocumentsFindView>>
  > = ({ signal }) => cmsAdminApiV2betaDocumentsFindView(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof cmsAdminApiV2betaDocumentsFindView>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const cmsAdminApiV2betaDetailView = (
  id: string,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/cms/admin/api/v2beta/pages/${id}/`,
    method: 'get',
    signal,
  });
};

export const getCmsAdminApiV2betaDetailViewQueryKey = (id: string) => [
  `/cms/admin/api/v2beta/pages/${id}/`,
];

export type CmsAdminApiV2betaDetailViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof cmsAdminApiV2betaDetailView>>
>;
export type CmsAdminApiV2betaDetailViewQueryError = ErrorType<unknown>;

export const useCmsAdminApiV2betaDetailView = <
  TData = Awaited<ReturnType<typeof cmsAdminApiV2betaDetailView>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof cmsAdminApiV2betaDetailView>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCmsAdminApiV2betaDetailViewQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof cmsAdminApiV2betaDetailView>>
  > = ({ signal }) => cmsAdminApiV2betaDetailView(id, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof cmsAdminApiV2betaDetailView>>,
    TError,
    TData
  >(queryKey, queryFn, { enabled: !!id, ...queryOptions }) as UseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const cmsAdminApiV2betaImagesFindView = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/cms/admin/api/v2beta/images/find/`,
    method: 'get',
    signal,
  });
};

export const getCmsAdminApiV2betaImagesFindViewQueryKey = () => [
  `/cms/admin/api/v2beta/images/find/`,
];

export type CmsAdminApiV2betaImagesFindViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof cmsAdminApiV2betaImagesFindView>>
>;
export type CmsAdminApiV2betaImagesFindViewQueryError = ErrorType<unknown>;

export const useCmsAdminApiV2betaImagesFindView = <
  TData = Awaited<ReturnType<typeof cmsAdminApiV2betaImagesFindView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cmsAdminApiV2betaImagesFindView>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCmsAdminApiV2betaImagesFindViewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof cmsAdminApiV2betaImagesFindView>>
  > = ({ signal }) => cmsAdminApiV2betaImagesFindView(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof cmsAdminApiV2betaImagesFindView>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const cmsAdminApiV2betaPagesFindView = (signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/cms/admin/api/v2beta/pages/find/`,
    method: 'get',
    signal,
  });
};

export const getCmsAdminApiV2betaPagesFindViewQueryKey = () => [
  `/cms/admin/api/v2beta/pages/find/`,
];

export type CmsAdminApiV2betaPagesFindViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof cmsAdminApiV2betaPagesFindView>>
>;
export type CmsAdminApiV2betaPagesFindViewQueryError = ErrorType<unknown>;

export const useCmsAdminApiV2betaPagesFindView = <
  TData = Awaited<ReturnType<typeof cmsAdminApiV2betaPagesFindView>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cmsAdminApiV2betaPagesFindView>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCmsAdminApiV2betaPagesFindViewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof cmsAdminApiV2betaPagesFindView>>
  > = ({ signal }) => cmsAdminApiV2betaPagesFindView(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof cmsAdminApiV2betaPagesFindView>>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};
